<template>
  <Teleport to="body">
    <div v-show="!hidden" data-food-dialog class="fixed inset-0 z-[100] flex items-end justify-center" @click.self="$emit('close')">
      <div class="absolute inset-0 bg-black/40 backdrop-blur-[2px]" @click="$emit('close')" />

      <!-- Отступ снизу — под системные кнопки Android (--sheet-bottom в
           style.css); на нём же стоят камера и микрофон, а за ними кнопка «+»
           в Diary.vue -->
      <div class="relative w-full max-w-[430px] bg-cream rounded-t-3xl shadow-2xl flex flex-col"
           style="height: 84vh; padding-bottom: var(--sheet-bottom, 0px)">

        <!-- Контент: грид / поиск / форма порции. Шапка (заголовок и вкладки)
             и ряд тегов — внутри прокрутки и прилипают сверху, фон
             полупрозрачный с размытием, как у нижнего меню: плитки уходят
             под них, а не обрываются (владелец, 10.10.2026) -->
        <!-- overflow-x hidden: на iPhone лента при вертикальной прокрутке
             уезжала и вбок (владелец, 27.10.2026) -->
        <div ref="scrollEl" class="flex-1 overflow-y-auto overflow-x-hidden px-5 pb-3 flex flex-col" style="overscroll-behavior-x: none;">
          <div class="afd-head">
          <!-- Заголовок + крестик -->
          <div class="pt-5 pb-2 flex items-center justify-between">
            <h2 style="font-family: Inter, sans-serif; font-size: var(--fs-20); font-weight: 700; color: var(--ink);">Добавить в дневник</h2>
            <button @click="$emit('close')" class="w-8 h-8 flex items-center justify-center rounded-full text-ink active:bg-line transition-colors">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>

          <!-- Табы: Избранное / Мои рецепты / Ранее -->
          <div class="pb-3 flex gap-4 items-center">
            <button
              data-guide="tab-fav"
              @click="recentTab = 'favorites'"
              class="flex items-center gap-1 text-15 font-semibold transition-colors"
              :class="recentTab === 'favorites' ? 'text-ink' : 'text-ink/70'"
            >
              <svg width="16" height="14" viewBox="0 0 24 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M13.8131 18.2326C12.5923 19.442 10.7015 19.442 9.48071 18.2326L2.19973 11.019C-2.67113 6.14805 3.68934 -4.6136 11.6469 3.34396C19.5905 -4.59961 25.951 6.16221 21.0941 11.019L13.8131 18.2326Z"/>
              </svg>
              Избранное
            </button>
            <button
              data-guide="tab-recipes"
              @click="recentTab = 'recipes'"
              class="flex items-center gap-1 text-15 font-semibold transition-colors"
              :class="recentTab === 'recipes' ? 'text-ink' : 'text-ink/70'"
            >
              <svg width="16" height="14" viewBox="0 0 14 12" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                <path d="M7 2C8.72391 2 10.3772 2.68482 11.5962 3.90381C12.8152 5.12279 13.5 6.77609 13.5 8.5C13.5 8.76522 13.3946 9.0196 13.2071 9.2071C13.0196 9.3946 12.7652 9.5 12.5 9.5H1.5C1.23478 9.5 0.98043 9.3946 0.792893 9.2071C0.605357 9.0196 0.5 8.76522 0.5 8.5C0.5 6.77609 1.18482 5.12279 2.40381 3.90381C3.62279 2.68482 5.27609 2 7 2Z"/>
                <path d="M7 2V0.5"/>
                <path d="M0.5 11.5H13.5"/>
              </svg>
              Рецепты
            </button>
            <button
              data-guide="tab-recent"
              @click="recentTab = 'recent'"
              class="flex items-center gap-1 text-15 font-semibold transition-colors"
              :class="recentTab === 'recent' ? 'text-ink' : 'text-ink/70'"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                <path d="M7 3.5V7.5L9.6 8.8"/>
                <path d="M13.3261 8.5C12.6489 11.3667 10.0736 13.5 7 13.5C3.41015 13.5 0.5 10.5899 0.5 7C0.5 3.41015 3.41015 0.5 7 0.5C9.50772 0.5 11.6838 1.92011 12.7678 4" stroke-linejoin="miter"/>
                <path d="M13.5 2V4.5H11"/>
              </svg>
              Ранее
            </button>
          </div>
          <!-- Ряд тегов — внутри липкой шапки, одной полупрозрачной поверхностью
               с заголовком и вкладками: отдельная липкая полоска под шапкой
               рисовалась иначе (владелец, 27.10.2026). Показывается в том же
               состоянии, что плитки: не поиск, не выбранный продукт, список загружен -->
          <template v-if="!selectedProduct && !photoError && !query.trim()">
            <FavTagFilter v-if="recentTab === 'recipes' && !recipesLoading && recipesItems.length" class="afd-tags" v-model="recipesTagFilter" :items="recipesItems" />
            <FavTagFilter v-else-if="recentTab === 'recent' && !recentLoading && recentItems.length" class="afd-tags" v-model="recentTagFilter" :items="recentItems" />
            <FavTagFilter v-else-if="recentTab !== 'recipes' && recentTab !== 'recent' && !favLoading && favItems.length" class="afd-tags" v-model="favTagFilter" :items="favItems" />
          </template>
          </div>

          <!-- Состояние: выбран продукт из поиска -->
          <template v-if="selectedProduct">
            <div class="bg-white rounded-2xl px-4 py-3 mb-4">
              <p class="text-16 font-bold text-ink">{{ selectedProduct.name }}</p>
              <p v-if="showWeight" class="text-13 text-ink mt-0.5">
                {{ selectedProduct.kcal != null ? selectedProduct.kcal + ' ккал на 100 г' : 'нет данных о ккал' }}
              </p>
            </div>

            <!-- Штуки: у продуктов из набора BUILTIN_UNITS (яйца, бананы, яблоки,
                 хлеб, котлеты, печенье…) количество вводится в штуках, граммы
                 считаются рядом; «размер» открывает шторку с размерами. У остальных
                 только граммы (решение владельца 26.10.2026). -->
            <div class="flex items-center justify-between mb-2 ml-1">
              <label class="text-13 font-semibold text-ink/70">{{ manualUnit && weightMode === 'unit' ? `Сколько, ${manualUnit.name}` : 'Вес порции, г' }}</label>
              <div class="flex items-center gap-2">
                <div v-if="manualUnit" class="flex rounded-lg bg-white p-0.5">
                  <button @click="setWeightMode('unit')" class="px-2.5 py-0.5 rounded-md text-12 font-semibold" :class="weightMode === 'unit' ? 'bg-ink text-cream' : 'text-ink/70'">{{ manualUnit.name }}</button>
                  <button @click="setWeightMode('g')" class="px-2.5 py-0.5 rounded-md text-12 font-semibold" :class="weightMode === 'g' ? 'bg-ink text-cream' : 'text-ink/70'">г</button>
                </div>
                <button v-if="manualUnit" @click="unitSheetOpen = true" class="text-12 font-semibold text-ink/70 underline decoration-dotted">размер</button>
              </div>
            </div>
            <template v-if="manualUnit && weightMode === 'unit'">
              <div class="flex items-center gap-2 mb-4">
                <button @click="stepQty(-1)" class="w-12 h-12 rounded-2xl bg-white text-ink text-20 font-semibold active:bg-line">−</button>
                <input
                  :value="qtyStr"
                  @input="onQtyInput"
                  type="text"
                  inputmode="decimal"
                  placeholder="1"
                  class="flex-1 h-12 px-4 rounded-2xl bg-white text-ink text-18 font-bold text-center outline-none"
                />
                <button @click="stepQty(1)" class="w-12 h-12 rounded-2xl bg-white text-ink text-20 font-semibold active:bg-line">+</button>
              </div>
              <p class="text-13 text-ink/70 -mt-2 mb-4 ml-1">= {{ weight }} г · 1 {{ manualUnit.name }} ≈ {{ manualUnit.grams }} г</p>
            </template>
            <input
              v-else
              :value="weightStr"
              @input="onWeightInput"
              type="text"
              inputmode="decimal"
              placeholder="100"
              class="w-full h-12 px-4 rounded-2xl bg-white text-ink text-18 font-bold
                     outline-none mb-4"
            />
            <UnitSheet
              v-if="unitSheetOpen && selectedProduct"
              :title="selectedProduct.name"
              :product-id="selectedProduct.id"
              :unit="manualUnitOverride === undefined ? manualUnit : manualUnitOverride"
              :builtin-key="matchBuiltin(selectedProduct.name)"
              :weight-g="weight"
              @select="onUnitPicked"
              @close="unitSheetOpen = false"
            />

            <div v-if="weight > 0 && selectedProduct.kcal != null" class="bg-white rounded-2xl px-4 py-3 mb-6">
              <p class="text-13 font-semibold text-ink/70 mb-2">{{ showWeight ? `На порцию ${weight} г:` : 'На порцию:' }}</p>
              <div class="flex gap-2 flex-wrap">
                <span class="pill-kcal text-13 font-semibold">{{ portionKcal }} ккал</span>
                <span v-if="portionProtein != null" class="pill-protein text-13">Б {{ portionProtein }}</span>
                <span v-if="portionFat != null"     class="pill-fat     text-13">Ж {{ portionFat }}</span>
                <span v-if="portionCarbs != null"   class="pill-carbs   text-13">У {{ portionCarbs }}</span>
              </div>
            </div>

            <div class="flex flex-col gap-3">
              <p v-if="addError" class="text-13 text-red-600 text-center leading-snug px-1">{{ addError }}</p>
              <button
                @click="addEntry"
                :disabled="adding || weight <= 0"
                class="w-full py-3.5 rounded-2xl bg-ink text-cream text-16 font-semibold
                       disabled:opacity-40 active:scale-[0.98] transition-all"
              >
                {{ adding ? (slowAdd ? 'Добавляю… связь медленная' : 'Добавляю...') : netOffline ? 'Нет связи' : 'Добавить в дневник' }}
              </button>
              <button
                @click="selectedProduct = null; query = ''"
                class="w-full py-3 rounded-2xl bg-white text-ink text-15 font-semibold"
              >
                Выбрать другой продукт
              </button>
            </div>
          </template>

          <!-- Состояние: ошибка распознавания -->
          <template v-else-if="photoError">
            <div class="flex flex-col items-center justify-center gap-4 py-12">
              <p class="text-16 font-semibold text-ink/70">Не удалось распознать</p>
              <p class="text-13 text-ink/70 text-center">{{ photoError }}</p>
              <button
                @click="photoError = ''; photoPreviewUrl = null"
                class="px-8 py-3 rounded-2xl bg-ink text-cream text-15 font-semibold"
              >
                Попробовать снова
              </button>
            </div>
          </template>

          <!-- Состояние: поиск активен -->
          <template v-else-if="query.trim()">
            <div v-if="searching" class="flex justify-center pt-8">
              <div class="w-5 h-5 border-2 border-sand border-t-[#8B7B6B] rounded-full animate-spin" />
            </div>

            <div v-else-if="results.length > 0" class="flex flex-col gap-2">
              <button
                v-for="p in results"
                :key="p.id"
                @click="selectProduct(p)"
                class="w-full bg-white rounded-2xl px-3 py-3 text-left active:scale-[0.98] transition-transform"
              >
                <p class="text-15 font-normal text-ink leading-snug">{{ p.name }}</p>
                <div class="flex items-end justify-between mt-1.5">
                  <div class="flex flex-wrap gap-1.5">
                    <span class="pill-kcal text-12 font-medium">{{ fmtVal(p.kcal) }} ккал</span>
                    <span class="pill-protein text-12 font-medium">{{ fmtVal(p.protein) }} г</span>
                    <span class="pill-fat text-12 font-medium">{{ fmtVal(p.fat) }} г</span>
                    <span class="pill-carbs text-12 font-medium">{{ fmtVal(p.carbs) }} г</span>
                  </div>
                  <span v-if="sourceBadge(p)" class="text-11 font-medium shrink-0 ml-2" :style="{ color: sourceBadge(p).color }">
                    ✓ {{ sourceBadge(p).label }}
                  </span>
                </div>
              </button>
            </div>

            <div v-else-if="!searching" class="text-center pt-12">
              <p class="text-15 font-semibold text-ink">По запросу «{{ query }}» продукты не найдены</p>
              <button
                @click="showManualProduct = true"
                class="mt-4 px-6 py-3 rounded-2xl text-15 font-semibold"
                style="background: #41291A; color: var(--cream);"
              >Добавить новый продукт</button>
            </div>
          </template>

          <!-- Состояние по умолчанию: избранное / мои рецепты / ранее -->
          <template v-else>
            <!-- Таб: Мои рецепты -->
            <template v-if="recentTab === 'recipes'">
              <div v-if="recipesLoading" class="flex justify-center pt-8">
                <div class="w-5 h-5 border-2 border-sand border-t-[#8B7B6B] rounded-full animate-spin" />
              </div>

              <template v-else-if="recipesItems.length > 0">
              <p v-if="!recipesFiltered.length" class="text-13 text-ink/70 text-center pt-6">Нет блюд сразу со всеми выбранными тегами</p>
              <div class="grid grid-cols-3 gap-2">
                <div
                  v-for="(item, idx) in recipesFiltered"
                  :key="idx"
                  class="food-card bg-white rounded-2xl overflow-hidden text-left relative"
                >
                  <button
                    @click="onRecentClick(item)"
                    class="w-full text-left active:scale-[0.97] transition-transform"
                  >
                    <div class="relative w-full aspect-square">
                      <img v-if="item.photo_url" :src="imgUrl(item.photo_url)" alt="" class="food-photo w-full h-full object-cover" />
                      <div v-if="item.photo_url" class="food-vignette" />
                      <div v-else class="w-full h-full bg-[#F0EBE2] flex items-center justify-center">
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C4B8A8" stroke-width="1.5" stroke-linecap="round">
                          <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
                          <circle cx="12" cy="13" r="4"/>
                        </svg>
                      </div>
                      <div v-if="hasAnyPill" class="absolute top-1.5 left-1.5 flex flex-col gap-0.5 items-start">
                        <span v-if="showKcal" class="pill-kcal text-9 font-semibold">{{ Math.round(item.total_kcal) }}</span>
                        <span v-if="showProtein" class="pill-protein text-9">{{ Math.round(item.total_protein) }}</span>
                        <span v-if="showFat" class="pill-fat text-9">{{ Math.round(item.total_fat) }}</span>
                        <span v-if="showCarbs" class="pill-carbs text-9">{{ Math.round(item.total_carbs) }}</span>
                        <!-- Клетчатка есть не у всех продуктов: сервер отдаёт
                             null, когда её не разрешил ни один ингредиент.
                             Ноль в этом месте был бы неправдой, поэтому
                             пилюли просто нет. -->
                        <span v-if="showFiber && item.total_fiber != null" class="pill-fiber text-9">{{ Math.round(item.total_fiber) }}</span>
                      </div>
                      <!-- Иконка рецепта -->
                      <div
                        v-if="item.is_edited_cooking || (item.cooked_weight_g && Number(item.cooked_weight_g) > 0)"
                        class="absolute bottom-1.5 right-1.5 w-8 h-8 rounded-full bg-black/20 backdrop-blur-sm flex items-center justify-center"
                      >
                        <svg width="16" height="14" viewBox="0 0 14 12" fill="none" stroke="#FAF3E8" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M7 2C8.72391 2 10.3772 2.68482 11.5962 3.90381C12.8152 5.12279 13.5 6.77609 13.5 8.5C13.5 8.76522 13.3946 9.0196 13.2071 9.2071C13.0196 9.3946 12.7652 9.5 12.5 9.5H1.5C1.23478 9.5 0.98043 9.3946 0.792893 9.2071C0.605357 9.0196 0.5 8.76522 0.5 8.5C0.5 6.77609 1.18482 5.12279 2.40381 3.90381C3.62279 2.68482 5.27609 2 7 2Z"/>
                          <path d="M7 2V0.5"/>
                          <path d="M0.5 11.5H13.5"/>
                        </svg>
                      </div>
                    </div>
                    <div class="px-2.5 py-2">
                      <p class="text-11 font-semibold text-ink leading-tight line-clamp-2">{{ showWeight ? item.label : (item.name || item.label) }}</p>
                    </div>
                  </button>
                  <!-- Сердечко -->
                  <button
                    v-if="item.dish_id"
                    @click.stop="toggleFavorite(item)"
                    class="absolute top-1.5 right-1.5 w-8 h-8 rounded-full bg-black/20 backdrop-blur-sm flex items-center justify-center active:scale-90 transition-transform"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 20" :fill="item.is_favorite ? '#FF6B6B' : 'none'" :stroke="item.is_favorite ? '#FF6B6B' : 'white'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M13.8131 18.2326C12.5923 19.442 10.7015 19.442 9.48071 18.2326L2.19973 11.019C-2.67113 6.14805 3.68934 -4.6136 11.6469 3.34396C19.5905 -4.59961 25.951 6.16221 21.0941 11.019L13.8131 18.2326Z"/>
                    </svg>
                  </button>
                </div>
              </div>
              </template>

              <ZoyaBubble v-else class="empty-state-bubble">
            <p>{{ ty ? 'Создавай' : 'Создавайте' }} рецепты на странице «Мои рецепты» и {{ ty ? 'добавляй' : 'добавляйте' }} блюда на их основе из этой вкладки</p>
          </ZoyaBubble>
            </template>

            <!-- Таб: Ранее -->
            <template v-else-if="recentTab === 'recent'">
              <div v-if="recentLoading" class="flex justify-center pt-8">
                <div class="w-5 h-5 border-2 border-sand border-t-[#8B7B6B] rounded-full animate-spin" />
              </div>

              <template v-else-if="recentItems.length > 0">
              <p v-if="!recentFiltered.length" class="text-13 text-ink/70 text-center pt-6">Нет блюд сразу со всеми выбранными тегами</p>
              <div class="grid grid-cols-3 gap-2">
                <div
                  v-for="(item, idx) in recentFiltered"
                  :key="idx"
                  class="food-card bg-white rounded-2xl overflow-hidden text-left relative"
                >
                  <button
                    @click="onRecentClick(item)"
                    class="w-full text-left active:scale-[0.97] transition-transform"
                  >
                    <!-- Фото или плейсхолдер -->
                    <div class="relative w-full aspect-square">
                      <img v-if="item.photo_url" :src="imgUrl(item.photo_url)" alt="" class="food-photo w-full h-full object-cover" />
                      <div v-if="item.photo_url" class="food-vignette" />
                      <div v-else class="w-full h-full bg-[#F0EBE2] flex items-center justify-center">
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C4B8A8" stroke-width="1.5" stroke-linecap="round">
                          <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
                          <circle cx="12" cy="13" r="4"/>
                        </svg>
                      </div>
                      <div v-if="hasAnyPill" class="absolute top-1.5 left-1.5 flex flex-col gap-0.5 items-start">
                        <span v-if="showKcal" class="pill-kcal text-9 font-semibold">{{ Math.round(item.total_kcal) }}</span>
                        <span v-if="showProtein" class="pill-protein text-9">{{ Math.round(item.total_protein) }}</span>
                        <span v-if="showFat" class="pill-fat text-9">{{ Math.round(item.total_fat) }}</span>
                        <span v-if="showCarbs" class="pill-carbs text-9">{{ Math.round(item.total_carbs) }}</span>
                        <!-- Клетчатка есть не у всех продуктов: сервер отдаёт
                             null, когда её не разрешил ни один ингредиент.
                             Ноль в этом месте был бы неправдой, поэтому
                             пилюли просто нет. -->
                        <span v-if="showFiber && item.total_fiber != null" class="pill-fiber text-9">{{ Math.round(item.total_fiber) }}</span>
                      </div>
                      <!-- Иконка рецепта -->
                      <div
                        v-if="item.is_edited_cooking || (item.cooked_weight_g && Number(item.cooked_weight_g) > 0)"
                        class="absolute bottom-1.5 right-1.5 w-8 h-8 rounded-full bg-black/20 backdrop-blur-sm flex items-center justify-center"
                      >
                        <svg width="16" height="14" viewBox="0 0 14 12" fill="none" stroke="#FAF3E8" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M7 2C8.72391 2 10.3772 2.68482 11.5962 3.90381C12.8152 5.12279 13.5 6.77609 13.5 8.5C13.5 8.76522 13.3946 9.0196 13.2071 9.2071C13.0196 9.3946 12.7652 9.5 12.5 9.5H1.5C1.23478 9.5 0.98043 9.3946 0.792893 9.2071C0.605357 9.0196 0.5 8.76522 0.5 8.5C0.5 6.77609 1.18482 5.12279 2.40381 3.90381C3.62279 2.68482 5.27609 2 7 2Z"/>
                          <path d="M7 2V0.5"/>
                          <path d="M0.5 11.5H13.5"/>
                        </svg>
                      </div>
                    </div>

                    <!-- Инфо -->
                    <div class="px-2.5 py-2">
                      <p class="text-11 font-semibold text-ink leading-tight line-clamp-2">{{ showWeight ? item.label : (item.name || item.label) }}</p>
                    </div>
                  </button>

                  <!-- Сердечко — избранное -->
                  <button
                    v-if="item.dish_id"
                    @click.stop="toggleFavorite(item)"
                    class="absolute top-1.5 right-1.5 w-8 h-8 rounded-full bg-black/20 backdrop-blur-sm flex items-center justify-center active:scale-90 transition-transform"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 20" :fill="item.is_favorite ? '#FF6B6B' : 'none'" :stroke="item.is_favorite ? '#FF6B6B' : 'white'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M13.8131 18.2326C12.5923 19.442 10.7015 19.442 9.48071 18.2326L2.19973 11.019C-2.67113 6.14805 3.68934 -4.6136 11.6469 3.34396C19.5905 -4.59961 25.951 6.16221 21.0941 11.019L13.8131 18.2326Z"/>
                    </svg>
                  </button>
                </div>
              </div>
              </template>

              <ZoyaBubble v-else class="empty-state-bubble">
            <p>Из этой вкладки можно повторно добавлять ранее добавленные в Дневник блюда и продукты</p>
          </ZoyaBubble>
            </template>

            <!-- Таб: Избранное -->
            <template v-else>
              <div v-if="favLoading" class="flex justify-center pt-8">
                <div class="w-5 h-5 border-2 border-sand border-t-[#8B7B6B] rounded-full animate-spin" />
              </div>

              <template v-else-if="favItems.length > 0">
              <p v-if="!favFiltered.length" class="text-13 text-ink/70 text-center pt-6">Нет блюд сразу со всеми выбранными тегами</p>
              <div class="grid grid-cols-3 gap-2">
                <div
                  v-for="item in favFiltered"
                  :key="item.dish_id"
                  class="food-card bg-white rounded-2xl overflow-hidden text-left relative"
                >
                  <button
                    @click="onRecentClick(item)"
                    class="w-full text-left active:scale-[0.97] transition-transform"
                  >
                    <div class="relative w-full aspect-square">
                      <img v-if="item.photo_url" :src="imgUrl(item.photo_url)" alt="" class="food-photo w-full h-full object-cover" />
                      <div v-if="item.photo_url" class="food-vignette" />
                      <div v-else class="w-full h-full bg-[#F0EBE2] flex items-center justify-center">
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C4B8A8" stroke-width="1.5" stroke-linecap="round">
                          <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
                          <circle cx="12" cy="13" r="4"/>
                        </svg>
                      </div>
                      <div v-if="hasAnyPill" class="absolute top-1.5 left-1.5 flex flex-col gap-0.5 items-start">
                        <span v-if="showKcal" class="pill-kcal text-9 font-semibold">{{ Math.round(item.total_kcal) }}</span>
                        <span v-if="showProtein" class="pill-protein text-9">{{ Math.round(item.total_protein) }}</span>
                        <span v-if="showFat" class="pill-fat text-9">{{ Math.round(item.total_fat) }}</span>
                        <span v-if="showCarbs" class="pill-carbs text-9">{{ Math.round(item.total_carbs) }}</span>
                        <!-- Клетчатка есть не у всех продуктов: сервер отдаёт
                             null, когда её не разрешил ни один ингредиент.
                             Ноль в этом месте был бы неправдой, поэтому
                             пилюли просто нет. -->
                        <span v-if="showFiber && item.total_fiber != null" class="pill-fiber text-9">{{ Math.round(item.total_fiber) }}</span>
                      </div>
                      <!-- Иконка рецепта -->
                      <div
                        v-if="item.is_edited_cooking || (item.cooked_weight_g && Number(item.cooked_weight_g) > 0)"
                        class="absolute bottom-1.5 right-1.5 w-8 h-8 rounded-full bg-black/20 backdrop-blur-sm flex items-center justify-center"
                      >
                        <svg width="16" height="14" viewBox="0 0 14 12" fill="none" stroke="#FAF3E8" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M7 2C8.72391 2 10.3772 2.68482 11.5962 3.90381C12.8152 5.12279 13.5 6.77609 13.5 8.5C13.5 8.76522 13.3946 9.0196 13.2071 9.2071C13.0196 9.3946 12.7652 9.5 12.5 9.5H1.5C1.23478 9.5 0.98043 9.3946 0.792893 9.2071C0.605357 9.0196 0.5 8.76522 0.5 8.5C0.5 6.77609 1.18482 5.12279 2.40381 3.90381C3.62279 2.68482 5.27609 2 7 2Z"/>
                          <path d="M7 2V0.5"/>
                          <path d="M0.5 11.5H13.5"/>
                        </svg>
                      </div>
                    </div>

                    <div class="px-2.5 py-2">
                      <p class="text-11 font-semibold text-ink leading-tight line-clamp-2">{{ showWeight ? item.label : (item.name || item.label) }}</p>
                    </div>
                  </button>

                  <!-- Сердечко — убрать из избранного -->
                  <button
                    @click.stop="toggleFavorite(item)"
                    class="absolute top-1.5 right-1.5 w-8 h-8 rounded-full bg-black/20 backdrop-blur-sm flex items-center justify-center active:scale-90 transition-transform"
                  >
                    <svg width="16" height="14" viewBox="0 0 24 20" fill="#FF6B6B" stroke="#FF6B6B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M13.8131 18.2326C12.5923 19.442 10.7015 19.442 9.48071 18.2326L2.19973 11.019C-2.67113 6.14805 3.68934 -4.6136 11.6469 3.34396C19.5905 -4.59961 25.951 6.16221 21.0941 11.019L13.8131 18.2326Z"/>
                    </svg>
                  </button>
                </div>
              </div>
              </template>

              <ZoyaBubble v-else class="empty-state-bubble">
            <p>{{ ty ? 'Добавь' : 'Добавьте' }} первое блюдо в Избранное,<br>нажав на сердечко на фото блюда</p>
          </ZoyaBubble>
            </template>
          </template>

        </div>

        <!-- Нижний блок: камера FAB + input с иконками -->
        <div v-if="!selectedProduct && !photoError" class="shrink-0 px-5 pb-7 pt-2 bg-cream relative">

          <!-- Кнопка камеры — круглая FAB над input'ом, справа. Обе FAB прячутся,
               пока в поле есть текст: человек ищет по базе сам, кнопки висели
               над результатами (просьба владельца 8.10.2026) -->
          <button
            v-if="!searchTyped"
            data-guide="camera"
            @click="openCamera"
            @contextmenu.prevent
            class="absolute w-[90px] h-[90px] rounded-full glass-fab flex items-center justify-center active:scale-95 transition-transform"
            style="right: 20px; bottom: calc(100% + 17px);"
          >
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#FAF3E8" stroke-width="1.5" stroke-linecap="round">
              <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
              <circle cx="12" cy="13" r="4"/>
            </svg>
          </button>

          <!-- Голосовой ввод — такая же FAB слева от камеры. Только там, где
               браузер умеет писать звук (старые WebView — нет) -->
          <button
            v-if="voiceSupported && !searchTyped"
            @click="onVoiceClick"
            @pointerdown="onVoiceHoldStart"
            @pointerup="onVoiceHoldEnd"
            @pointercancel="onVoiceHoldEnd"
            @pointerleave="onVoiceHoldEnd"
            @contextmenu.prevent
            aria-label="Голосовой ввод"
            class="absolute w-[90px] h-[90px] rounded-full glass-fab flex items-center justify-center active:scale-95 transition-transform"
            style="right: 124px; bottom: calc(100% + 17px);"
          >
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#FAF3E8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <rect x="9" y="2" width="6" height="12" rx="3"/>
              <path d="M5 11a7 7 0 0 0 14 0"/>
              <line x1="12" y1="18" x2="12" y2="22"/>
              <line x1="8.5" y1="22" x2="15.5" y2="22"/>
            </svg>
          </button>

          <!-- Input с иконками штрихкода и скрепки внутри -->
          <div class="input-shell relative">
            <input
              ref="searchRef"
              v-model="query"
              type="text"
              placeholder="Поиск продукта"
              aria-label="Поиск продукта"
              @focus="guide.done('add_ways')"
              class="w-full h-[56px] pl-4"
              :class="query ? 'pr-10' : 'pr-[8rem]'"
              autocomplete="off"
              autocorrect="off"
              spellcheck="false"
              @input="onInput"
            />
            <!-- Когда есть текст — крестик очистки -->
            <button
              v-if="query"
              @click="query = ''; results = []; selectedProduct = null"
              class="absolute right-3 top-1/2 -translate-y-1/2 text-ink/60"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
            <!-- Когда нет текста — иконки добавления, штрихкода и галереи -->
            <div v-else class="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-1">
              <button
                @click="showManualProduct = true"
                class="w-10 h-10 flex items-center justify-center rounded-xl text-ink active:bg-[#E0D9CF] transition-colors"
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                  <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                </svg>
              </button>
              <button
                @click="onBarcode"
                class="w-10 h-10 flex items-center justify-center rounded-xl text-ink active:bg-[#E0D9CF] transition-colors"
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
                  <path d="M2 4h2v16H2zM6 4h1v16H6zM10 4h2v16h-2zM15 4h1v16h-1zM19 4h3v16h-3z"/>
                </svg>
              </button>
              <button
                @click="openGallery"
                class="w-10 h-10 flex items-center justify-center rounded-xl text-ink active:bg-[#E0D9CF] transition-colors"
              >
                <svg width="22" height="22" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.5 13.5H12.5C13.0523 13.5 13.5 13.0523 13.5 12.5V1.5C13.5 0.947715 13.0523 0.5 12.5 0.5H1.5C0.947715 0.5 0.5 0.947715 0.5 1.5V12.5C0.5 13.0523 0.947715 13.5 1.5 13.5Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M1.75 13.5L9.05 6.61996C9.13984 6.54513 9.25307 6.50415 9.37 6.50415C9.48692 6.50415 9.60015 6.54513 9.68999 6.61996L13.5 9.34996" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4.5 6C5.32843 6 6 5.32843 6 4.5C6 3.67157 5.32843 3 4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.32843 3.67157 6 4.5 6Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Hidden file inputs -->
        <input
          ref="cameraInput"
          type="file"
          accept="image/*"
          capture="environment"
          class="hidden"
          @change="onPhotoSelected"
        />
        <input
          ref="galleryInput"
          type="file"
          accept="image/*"
          class="hidden"
          @change="onPhotoSelected"
        />

      </div>
    </div>

    <VoiceRecordSheet v-if="showVoiceSheet" @close="showVoiceSheet = false" @recorded="onVoiceRecorded" />

    <!-- Страница 2: результаты распознавания / быстрый повтор -->
    <PhotoRecognizeDialog
      v-if="showPage2"
      :voice="page2Voice"
      :voice-transcript="page2Transcript"
      :icons="page2Icons"
      :loading="page2Loading"
      :mode="page2Mode"
      :items="page2Items"
      :photo-url="page2PhotoUrl"
      :preview-url="photoPreviewUrl"
      :confidence="page2Confidence"
      :recognition-id="page2RecognitionId"
      :portions-count="page2PortionsCount"
      :photo-base64="page2Base64"
      :photo-mime="page2Mime"
      :dish-name-prop="page2DishName"

      :dish-id="page2DishId"
      :initial-favorite="page2IsFavorite"
      :is-edited-cooking="page2IsEditedCooking"
      :cooked-weight-g="page2CookedWeightG"
      :enriching="page2Enriching"
      :eaten-at="eatenAt"
      :draft="page2Draft"
      @close="showPage2 = false"
      @added="onPhotoAdded"
      @tags-changed="onDishTagsChanged"
    />

    <!-- Сканер штрихкодов -->
    <BarcodeScannerDialog
      v-if="showBarcodeScanner"
      v-model="showBarcodeScanner"
      :eaten-at="eatenAt"
      @added="(e) => { guide.journey('j_saved', { src: 'barcode' }); emit('added', e); emit('close') }"
    />

    <!-- Диалог ручного добавления нового продукта (кнопка "+") -->
    <LabelReviewDialog
      v-if="showManualProduct"
      v-model="showManualProduct"
      :show-barcode-scanner="true"
      :start-in-review="true"
      :initial-data="labelRestoreData"
      :barcode="labelRestoreBarcode"
      @submitted="onManualProductSubmitted"
    />

    <!-- Промежуточный экран проверки package-продукта -->
    <LabelReviewDialog
      v-if="showPackageReview"
      v-model="showPackageReview"
      :barcode="packageReviewItem?.barcode || null"
      :initial-data="{
        name: packageReviewItem?.name,
        brand: packageReviewItem?.brand,
        per100: packageReviewItem?.label_kbju,
        ingredients_text: packageReviewItem?.ingredients_text,
      }"
      :show-barcode-scanner="true"
      :header-text="packageReviewItem?.label_kbju?.kcal != null ? 'Вижу этикетку продукта' : null"
      @submitted="onPackageReviewSubmitted"
      @found-existing="onPackageFoundExisting"
      @update:model-value="v => { if (!v) onPackageReviewClosed() }"
    />
  </Teleport>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import api from '../services/api.js'
import { isAiAccessError } from '../services/aiAccess.js'
import { PHOTO_PROMPT_VERSION } from '../utils/promptVersions'
import { useUnitsStore } from '../store/units.js'
import { unitFor, matchBuiltin, qtyFromGrams, gramsFromQty, mergeEntryUnits } from '../utils/units.js'
import UnitSheet from './UnitSheet.vue'
import { uuid } from '../utils/uuid.js'
import { describeSaveError, isNetworkFailure } from '../utils/saveError.js'
import { offline as netOffline, registerPendingSave, unregisterPendingSave } from '../services/netStatus.js'
import { markUnsaved, clearUnsaved } from '../services/unsaved.js'
import { saveDraft, clearDraft, getPhoto } from '../services/drafts.js'
import { startNetProbe } from '../utils/netdiag.js'
import { withAiJob } from '../utils/aiProgress.js'
import { imgUrl } from '../utils/image.js'
import { useAuthStore } from '../store/auth.js'
import PhotoRecognizeDialog from './PhotoRecognizeDialog.vue'
import VoiceRecordSheet from './VoiceRecordSheet.vue'
import FavTagFilter, { matchesTags } from './FavTagFilter.vue'
import BarcodeScannerDialog from './BarcodeScannerDialog.vue'
import LabelReviewDialog from './LabelReviewDialog.vue'
import { track } from '../analytics.js'
import guide, { state as guideState } from '../services/guide.js'
import ZoyaBubble from './ZoyaBubble.vue'

// Порог похожести, с которого имя карточки заменяет распознанное (lib/estimateConflict.js)
const STRONG_NAME_SIMILARITY = 0.7

// Модель иногда кладёт в label_kbju цифры с лицевой стороны упаковки на всю
// порцию: «33 g protein / 340 ml» превращалось в «белки 33 на 100 г», и окно
// «Вижу этикетку» предлагало занести в общую базу втрое завышенную карточку
// (18.10.2026, три прогона из трёх на фото бутылки). Признак — белок или
// калории «этикетки» совпадают с её же оценкой на всю порцию, а порция заметно
// больше 100 г. Такую «этикетку» не используем: дальше работает оценка модели.
function labelLooksPerPortion(item) {
  const l = item?.label_kbju, f = item?.fallback_kbju, w = Number(item?.weight_g)
  if (!l || !f || !(w >= 150)) return false
  const same = (a, b, min) => a != null && b != null && Number(b) >= min && Math.abs(Number(a) - Number(b)) <= Math.max(1, Number(b) * 0.1)
  return same(l.protein, f.protein, 5) || same(l.kcal, f.kcal, 50)
}

const authStore = useAuthStore()
const ty = computed(() => authStore.user?.address_form !== 'вы')
const ds = computed(() => authStore.user?.diary_settings || {})
const showWeight = computed(() => ds.value.show_weight ?? true)
const photoMaxQuality = computed(() => ds.value.photo_max_quality === true)
const showKcal = computed(() => ds.value.show_kcal ?? true)
const showProtein = computed(() => ds.value.show_protein ?? true)
const showFat = computed(() => ds.value.show_fat ?? true)
const showCarbs = computed(() => ds.value.show_carbs ?? true)
const showFiber = computed(() => ds.value.show_fiber ?? true)
const hasAnyPill = computed(() => showKcal.value || showProtein.value || showFat.value || showCarbs.value || showFiber.value)

const props = defineProps({
  date: String,
  eatenAt: { type: String, default: null },
  hidden: { type: Boolean, default: false },
  // Черновик, который надо продолжить (services/drafts.js): meal — окно
  // распознавания, product — продукт из базы с весом, label — карточка
  // нового продукта. Дневник передаёт его после вопроса «Продолжить?».
  restore: { type: Object, default: null },
  // Вкладка верхнего блока при открытии: 'favorites' | 'recipes' | 'recent'
  // (карточка «Первые шаги» открывает «Ранее» для повтора)
  initialTab: { type: String, default: null },
})
const emit = defineEmits(['close', 'added', 'favorite-toggled'])

// Пока окно открыто, автообновление не перезагружает страницу
const unsavedKey = Symbol('AddFoodDialog')
onMounted(() => { markUnsaved(unsavedKey) })

// Подсказки Зои: в первый раз — способы добавления у камеры, потом —
// повтор у вкладки «Ранее» (когда в дневнике уже что-то есть)
onMounted(() => {
  guide.journey('j_add')
  if (props.restore || props.initialTab) return
  if (guide.request('add_ways', { anchor: '[data-guide="camera"]', place: 'above' })) return
  if (guideState.has_entries) guide.request('repeat', { anchor: '[data-guide="tab-recent"]', place: 'below' })
})
onUnmounted(() => { for (const k of ['add_ways', 'repeat', 'empty_fav', 'empty_recipes', 'empty_recent']) guide.hide(k) })

onUnmounted(() => {
  clearUnsaved(unsavedKey)
  // Закрытие — настоящее (перезагрузка окно не размонтирует): черновик
  // продукта больше не нужен. Черновик приёма снимает само окно распознавания.
  clearDraft('product')
})

// Блокируем скролл фона при открытом попапе (включая iOS)
let savedScrollY = 0
onMounted(() => {
  savedScrollY = window.scrollY
  document.body.style.position = 'fixed'
  document.body.style.top = `-${savedScrollY}px`
  document.body.style.left = '0'
  document.body.style.right = '0'
  document.body.style.overflow = 'hidden'
})
onUnmounted(() => {
  document.body.style.position = ''
  document.body.style.top = ''
  document.body.style.left = ''
  document.body.style.right = ''
  document.body.style.overflow = ''
  window.scrollTo(0, savedScrollY)
})

// keep-alive: снимаем/восстанавливаем scroll lock при скрытии/показе
watch(() => props.hidden, (hidden) => {
  if (hidden) {
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.left = ''
    document.body.style.right = ''
    document.body.style.overflow = ''
  } else {
    document.body.style.position = 'fixed'
    document.body.style.top = `-${savedScrollY}px`
    document.body.style.left = '0'
    document.body.style.right = '0'
    document.body.style.overflow = 'hidden'
  }
})

// ── Сканер штрихкодов ────────────────────────────────
const showBarcodeScanner = ref(false)

// ── Табы ──────────────────────────────────────────────
const recentTab = ref(['favorites', 'recipes', 'recent'].includes(props.initialTab) ? props.initialTab : 'favorites')

// ── Поиск ─────────────────────────────────────────────
const query = ref('')
const scrollEl = ref(null)
// В поле поиска есть текст — FAB камеры и микрофона скрыты
const searchTyped = computed(() => query.value.trim().length > 0)
watch(searchTyped, (v) => { if (v) guide.journey('j_search') })
const results = ref([])
const searching = ref(false)
const selectedProduct = ref(null)
const weight = ref(100)
const weightStr = ref('100')
function onWeightInput(e) {
  const raw = e.target.value.replace(',', '.')
  weightStr.value = e.target.value
  const num = parseFloat(raw)
  weight.value = isNaN(num) ? 0 : num
}
const adding = ref(false)
// Сохранение дольше 5 с — «связь медленная» в кнопке; обрыв — окно остаётся
// и повторяет отправку само при возврате связи (netStatus, ключи те же)
const slowAdd = ref(false)
let slowAddTimer = null
const pendingSaveKey = Symbol('AddFoodDialog')
const addError = ref('')
let entryClientIds = null // ключи идемпотентности текущего продукта, см. addEntry
const searchRef = ref(null)
let debounceTimer = null

function onInput() {
  clearTimeout(debounceTimer)
  selectedProduct.value = null
  if (!query.value.trim()) { results.value = []; return }
  debounceTimer = setTimeout(search, 300)
}

async function search() {
  searching.value = true
  try {
    const { data } = await api.get('/products/search', {
      params: { q: query.value, limit: 40 },
    })
    results.value = data.products || []
  } catch {
    results.value = []
  } finally {
    searching.value = false
  }
}

function selectProduct(p) {
  entryClientIds = null
  addError.value = ''
  selectedProduct.value = p
  manualUnitOverride.value = undefined
  const u = unitFor({ name: p.name, product_id: p.id }, unitsStore.personal)
  if (u) {
    // Штучный продукт: по умолчанию одна штука
    weightMode.value = 'unit'
    qty.value = 1; qtyStr.value = '1'
    weight.value = u.grams; weightStr.value = String(u.grams)
  } else {
    weightMode.value = 'g'
    weight.value = 100
    weightStr.value = '100'
  }
}

// ── Штуки и порции при ручном добавлении (utils/units.js) ──
const unitsStore = useUnitsStore()
unitsStore.load()
const manualUnitOverride = ref(undefined)   // выбор из шторки; undefined — не трогали


const manualUnit = computed(() => {
  if (!selectedProduct.value) return null
  if (manualUnitOverride.value !== undefined) return manualUnitOverride.value
  return unitFor({ name: selectedProduct.value.name, product_id: selectedProduct.value.id }, unitsStore.personal)
})
const weightMode = ref('g')
const qty = ref(1)
const qtyStr = ref('1')
const unitSheetOpen = ref(false)
function setWeightMode(m) {
  weightMode.value = m
  if (m === 'unit' && manualUnit.value) {
    // Переход в штуки: сколько это штук при текущем весе
    qty.value = qtyFromGrams(weight.value, manualUnit.value.grams) || 1
    qtyStr.value = String(qty.value)
  }
}
function onQtyInput(e) {
  qtyStr.value = e.target.value
  const n = parseFloat(String(e.target.value).replace(',', '.'))
  qty.value = Number.isFinite(n) && n > 0 ? n : 0
  if (manualUnit.value) { weight.value = gramsFromQty(qty.value, manualUnit.value.grams) || 0; weightStr.value = String(weight.value) }
}
function stepQty(d) {
  const n = Math.max(0.5, Math.round(((qty.value || 0) + d) * 2) / 2)
  qty.value = n; qtyStr.value = String(n)
  if (manualUnit.value) { weight.value = gramsFromQty(n, manualUnit.value.grams) || 0; weightStr.value = String(weight.value) }
}
function onUnitPicked(u) {
  manualUnitOverride.value = u
  if (u) { weightMode.value = 'unit'; qty.value = 1; qtyStr.value = '1'; weight.value = u.grams; weightStr.value = String(u.grams) }
  else weightMode.value = 'g'
}

function fmtVal(val) {
  if (val === null || val === undefined) return '0'
  const n = parseFloat(val)
  if (isNaN(n)) return '0'
  return n % 1 === 0 ? String(n) : n.toFixed(1)
}

function sourceBadge(p) {
  const s = (p.source || '').toLowerCase()
  if (s.includes('скурихин') || s.includes('skurikhin')) return { label: 'Скурихин', color: '#2D6A4F' }
  if (s.includes('usda')) return { label: 'USDA', color: '#1A5A7A' }
  if (p.is_own) return { label: 'Добавлено мной', color: '#7A6B5D' }
  return null
}

const calc = (per100) => per100 != null ? Math.round(per100 * weight.value / 100 * 10) / 10 : null
const portionKcal    = computed(() => calc(selectedProduct.value?.kcal))
const portionProtein = computed(() => calc(selectedProduct.value?.protein))
const portionFat     = computed(() => calc(selectedProduct.value?.fat))
const portionCarbs   = computed(() => calc(selectedProduct.value?.carbs))
const portionFiber   = computed(() => calc(selectedProduct.value?.fiber))
const portionWater   = computed(() => calc(selectedProduct.value?.water))

async function addEntry() {
  if (!selectedProduct.value || weight.value <= 0) return
  adding.value = true
  addError.value = ''
  unregisterPendingSave(pendingSaveKey)
  slowAdd.value = false
  if (slowAddTimer) clearTimeout(slowAddTimer)
  slowAddTimer = setTimeout(() => { slowAdd.value = true }, 5000)
  try {
    // Сердечко в дневнике висит на блюде, а не на записи: избранное живёт в
    // zoya_dishes.is_favorite. Поэтому продукту из поиска, как и продукту со
    // штрихкода, заводим блюдо из одной позиции — иначе карточка остаётся
    // единственной в дневнике без возможности добавить её в избранное.
    // Ошибку глотаем намеренно: не добавить продукт в дневник из-за
    // несозданного блюда хуже, чем добавить его без сердечка.
    // Блюдо и запись — одним идемпотентным запросом (POST /diary/entries).
    // Ключи живут до смены продукта: повторное нажатие после обрыва связи
    // уходит с теми же ключами и не даёт дубля.
    if (!entryClientIds) entryClientIds = { batch: uuid(), entry: uuid() }
    const { data } = await api.post('/diary/entries', {
      client_id: entryClientIds.batch,
      // Сердечко в дневнике висит на блюде, а не на записи: избранное живёт в
      // zoya_dishes.is_favorite. Поэтому продукту из поиска, как и продукту со
      // штрихкода, заводим блюдо из одной позиции — иначе карточка остаётся
      // единственной в дневнике без возможности добавить её в избранное.
      dish: { name: selectedProduct.value.name, photo_url: selectedProduct.value.image_url || null },
      entries: [{
        client_id:    entryClientIds.entry,
        product_id:   selectedProduct.value.id,
        product_name: selectedProduct.value.name,
        weight_g:     weight.value,
        kcal:         portionKcal.value,
        protein:      portionProtein.value,
        fat:          portionFat.value,
        carbs:        portionCarbs.value,
        fiber:        portionFiber.value   ?? null,
        water_ml:     portionWater.value   ?? null,
        eaten_at:     props.eatenAt || new Date().toISOString(),
        source:       'manual',
        // Штуки и порции — как было введено; в граммах тройка пустая
        qty:          manualUnit.value && weightMode.value === 'unit' && qty.value > 0 ? qty.value : null,
        unit_name:    manualUnit.value && weightMode.value === 'unit' ? manualUnit.value.name : null,
        unit_g:       manualUnit.value && weightMode.value === 'unit' ? manualUnit.value.grams : null,
      }],
    }, { idempotent: true })
    const entry = data.entries[0]
    const dishId = data.dish_id
    entryClientIds = null
    track('food_added_manual', { product_name: selectedProduct.value.name, weight_g: weight.value })
    // Дневник рисует карточку из того, что вернул POST, не перезапрашивая день:
    // без этих полей сердечко появится только после перезагрузки.
    if (dishId) {
      entry.dish_id = dishId
      entry.dish_name = selectedProduct.value.name
      entry.is_favorite = false
    }
    if (selectedProduct.value.image_url) entry.product_image_url = selectedProduct.value.image_url
    guide.journey('j_saved', { src: 'manual' })
    emit('added', entry)
    emit('close')
  } catch (err) {
    addError.value = describeSaveError(err)
    if (isNetworkFailure(err)) registerPendingSave(pendingSaveKey, () => addEntry())
  } finally {
    adding.value = false
    if (slowAddTimer) { clearTimeout(slowAddTimer); slowAddTimer = null }
    slowAdd.value = false
  }
}

onUnmounted(() => {
  unregisterPendingSave(pendingSaveKey)
  if (slowAddTimer) { clearTimeout(slowAddTimer); slowAddTimer = null }
})

// ── Ранее добавлено ───────────────────────────────────
const recentItems = ref([])
const recentLoading = ref(false)

async function loadRecent() {
  recentLoading.value = true
  try {
    const { data } = await api.get('/diary/recent', { params: { limit: 60 } })
    recentItems.value = data.items || []
  } catch {
    recentItems.value = []
  } finally {
    recentLoading.value = false
  }
}

// ── Избранное ─────────────────────────────────────────
const favItems = ref([])
const favLoading = ref(false)
let favLoaded = false

// Фильтр по тегам (FavTagFilter). Теги блюда меняют в карточке блюда —
// она сообщает сюда, чтобы фильтр обновился без перезагрузки списка.
const favTagFilter = ref([])
const favFiltered = computed(() => favItems.value.filter(it => matchesTags(it, favTagFilter.value)))
const recipesTagFilter = ref([])
const recipesFiltered = computed(() => recipesItems.value.filter(it => matchesTags(it, recipesTagFilter.value)))
const recentTagFilter = ref([])
const recentFiltered = computed(() => recentItems.value.filter(it => matchesTags(it, recentTagFilter.value)))
function onDishTagsChanged({ dishId, tags }) {
  let found = false
  for (const list of [favItems.value, recipesItems.value, recentItems.value]) {
    const item = list.find(it => it.dish_id === dishId)
    if (item) { item.tags = tags; found = true }
  }
  if (!found) favLoaded = false   // новое блюдо — список перечитается при открытии вкладки
}

async function loadFavorites() {
  favLoading.value = true
  try {
    const { data } = await api.get('/diary/dishes/favorites', { params: { limit: 200 } })
    favItems.value = data.items || []
  } catch {
    favItems.value = []
  } finally {
    favLoading.value = false
    favLoaded = true
  }
}

// ── Мои рецепты ──────────────────────────────────────
const recipesItems = ref([])
const recipesLoading = ref(false)

async function loadRecipes() {
  recipesLoading.value = true
  try {
    const { data } = await api.get('/cooking/my-recipes')
    recipesItems.value = data.items || []
  } catch {
    recipesItems.value = []
  } finally {
    recipesLoading.value = false
  }
}

async function toggleFavorite(item) {
  if (!item.dish_id) return
  try {
    const { data } = await api.patch(`/diary/dishes/${item.dish_id}/favorite`)
    item.is_favorite = data.is_favorite
    emit('favorite-toggled', { dishId: item.dish_id, isFavorite: data.is_favorite })
    // Обновляем список избранного
    if (data.is_favorite) {
      if (!favItems.value.find(f => f.dish_id === item.dish_id)) {
        favItems.value.unshift({ ...item, is_favorite: true })
      }
    } else {
      favItems.value = favItems.value.filter(f => f.dish_id !== item.dish_id)
    }
    // Синхронизируем is_favorite в списке рецептов
    const recipeItem = recipesItems.value.find(r => r.dish_id === item.dish_id)
    if (recipeItem) recipeItem.is_favorite = data.is_favorite
  } catch (err) {
    console.error('Toggle favorite error:', err)
  }
}

// Подгружаем данные при переключении на таб
watch(recentTab, (tab) => {
  if (tab === 'recent') { guide.done('repeat'); guide.journey('j_recent') }
  if (tab === 'recent' && recentItems.value.length === 0) loadRecent()
  if (tab === 'recipes' && recipesItems.value.length === 0 && !recipesLoading.value) loadRecipes()
})

onMounted(loadFavorites)

// ── Продолжить незаконченное (черновики) ─────────────
// Черновик ручного добавления: продукт выбран — помним его и вес, снят —
// забываем. Стоит после объявления qty и weightMode: watch читает источники
// сразу, и выше по файлу это была ошибка «до инициализации» при открытии окна.
watch([selectedProduct, weight, qty], ([p, w, q]) => {
  if (!p) { clearDraft('product'); return }
  saveDraft('product', {
    product: { id: p.id, name: p.name, brand: p.brand, kcal: p.kcal, protein: p.protein, fat: p.fat, carbs: p.carbs,
               fiber: p.fiber, water: p.water, image_url: p.image_url, source: p.source, is_own: p.is_own, nutrients: p.nutrients || null },
    weight: w, qty: q, weightMode: weightMode.value,
  })
})

const page2Draft = ref(null)
const labelRestoreData = ref(null)
const labelRestoreBarcode = ref(null)
onMounted(async () => {
  const d = props.restore
  if (!d) return
  if (d.kind === 'product' && d.product) {
    selectedProduct.value = d.product
    weightMode.value = d.weightMode === 'unit' ? 'unit' : 'g'
    if (d.qty > 0) { qty.value = d.qty; qtyStr.value = String(d.qty) }
    if (d.weight > 0) { weight.value = d.weight; weightStr.value = String(d.weight) }
    return
  }
  if (d.kind === 'label' && d.reviewData) {
    const r = d.reviewData
    labelRestoreData.value = {
      name: r.name, brand: r.brand, ingredients_text: r.ingredients_text,
      per100: { kcal: r.kcal, protein: r.protein, fat: r.fat, carbs: r.carbs, fiber: r.fiber },
    }
    labelRestoreBarcode.value = d.barcode || null
    showManualProduct.value = true
    return
  }
  if (d.kind === 'meal' && Array.isArray(d.items) && d.items.length) {
    page2Mode.value = d.mode || 'photo'
    page2Voice.value = !!d.voice
    page2Transcript.value = d.voiceTranscript || ''
    page2Items.value = d.items
    page2RecognitionId.value = d.recognitionId || null
    page2Confidence.value = d.confidence || 0
    page2PortionsCount.value = d.portionsCount || null
    page2PhotoUrl.value = d.photoUrl || null
    page2DishName.value = d.dishName || null
    page2DishId.value = d.dishId || null
    page2IsEditedCooking.value = !!d.isEditedCooking
    page2CookedWeightG.value = d.cookedWeightG || null
    page2Enriching.value = false
    page2Loading.value = false
    page2Base64.value = null
    photoPreviewUrl.value = null
    if (d.hasPhoto) {
      try {
        const ph = await getPhoto('meal')
        if (ph?.base64) {
          page2Base64.value = ph.base64
          page2Mime.value = ph.mime || 'image/jpeg'
          photoPreviewUrl.value = `data:${page2Mime.value};base64,${ph.base64}`
        }
      } catch { /* без фото тоже можно */ }
    }
    page2Draft.value = d
    showPage2.value = true
  }
})

// ── Страница 2 ───────────────────────────────────────
const showPage2 = ref(false)

const page2Loading = ref(false)
const page2Mode = ref('photo')
const page2Items = ref([])
// Распознавание, из которого открыто окно; уходит в PhotoRecognizeDialog
const page2RecognitionId = ref(null)
// Порций на рецепт — для повтора блюда порциями, а не граммами
const page2PortionsCount = ref(null)
const page2PhotoUrl = ref(null)
const page2Confidence = ref(0)
const page2Base64 = ref(null)
const page2Mime = ref('image/jpeg')
const page2DishName = ref(null)

const page2DishId = ref(null)
const page2IsFavorite = ref(false)
const page2IsEditedCooking = ref(false)
const page2CookedWeightG = ref(null)
const page2Enriching = ref(false)

// Ручное добавление продукта (кнопка "+")
const showManualProduct = ref(false)

function onManualProductSubmitted(result) {
  showManualProduct.value = false
  const p = result.product
  if (p?.id) {
    selectProduct({
      id: p.id,
      name: p.name,
      kcal: p.kcal ?? p.nutrients?.kcal ?? null,
      protein: p.protein ?? p.nutrients?.protein ?? null,
      fat: p.fat ?? p.nutrients?.fat ?? null,
      carbs: p.carbs ?? p.nutrients?.carbs ?? null,
      fiber: p.fiber ?? p.nutrients?.fiber ?? null,
      water: p.water ?? p.nutrients?.water ?? null,
      source: p.source || 'user',
      is_own: true,
    })
  }
}

// Package review — промежуточный экран проверки перед PhotoRecognizeDialog
const showPackageReview = ref(false)
const packageReviewItem = ref(null)

function mapEntriesToItems(entries) {
  return entries.map(e => ({
    name: e.product_name,
    type: 'direct',
    weight_g: parseFloat(e.weight_g) || 0,
    // Штуки и порции — как было введено (см. utils/units.js)
    qty: e.qty != null ? parseFloat(e.qty) : null,
    unit_name: e.unit_name || null,
    unit_g: e.unit_g != null ? parseFloat(e.unit_g) : null,
    product_id: e.product_id,
    db_name: e.product_name,
    matched: !!e.product_id,
    source: e.product_source || null,
    kcal:    parseFloat(e.kcal) || 0,
    protein: parseFloat(e.protein) || 0,
    fat:     parseFloat(e.fat) || 0,
    carbs:   parseFloat(e.carbs) || 0,
    fiber:   parseFloat(e.fiber) || null,
    water:   parseFloat(e.water_ml) || null,
    per100: {
      kcal:    e.weight_g ? Math.round(parseFloat(e.kcal) / parseFloat(e.weight_g) * 100 * 10) / 10 : null,
      protein: e.weight_g ? Math.round(parseFloat(e.protein) / parseFloat(e.weight_g) * 100 * 10) / 10 : null,
      fat:     e.weight_g ? Math.round(parseFloat(e.fat) / parseFloat(e.weight_g) * 100 * 10) / 10 : null,
      carbs:   e.weight_g ? Math.round(parseFloat(e.carbs) / parseFloat(e.weight_g) * 100 * 10) / 10 : null,
      fiber:   e.weight_g && e.fiber ? Math.round(parseFloat(e.fiber) / parseFloat(e.weight_g) * 100 * 10) / 10 : null,
      water:   e.weight_g && e.water_ml ? Math.round(parseFloat(e.water_ml) / parseFloat(e.weight_g) * 100 * 10) / 10 : null,
    },
    vitamins: e.vitamins || null,
  }))
}

function mapRecipeIngredientsToItems(ingredients) {
  return ingredients.map(ing => {
    const per100 = ing.per100 || {}
    const raw = ing.weight_g || 0
    const w = raw < 10 ? Math.round(raw * 10) / 10 : Math.round(raw)
    const hasSubIngredients = ing.ingredients?.length > 0
    const item = {
      name: ing.product_name || ing.name,
      type: hasSubIngredients ? 'recipe' : 'direct',
      weight_g: w,
      product_id: ing.product_id || null,
      db_name: ing.db_product_name || ing.db_name || null,
      matched: !!ing.product_id,
      // Откуда цифры у позиции без карточки: оценка модели или этикетка
      // (снимок блюда хранит estimate с 18.10.2026) — для меток «ИИ» и цвета
      _usedFallback: !ing.product_id && ing.estimate === 'ai',
      _hasLabelData: !ing.product_id && ing.estimate === 'label',
      source: ing.product_source || ing.source || null,
      kcal:    ing.kcal != null ? Math.round((ing.kcal || 0) * 10) / 10 : Math.round((per100.kcal || 0) * w / 100 * 10) / 10,
      protein: ing.protein != null ? Math.round((ing.protein || 0) * 10) / 10 : Math.round((per100.protein || 0) * w / 100 * 10) / 10,
      fat:     ing.fat != null ? Math.round((ing.fat || 0) * 10) / 10 : Math.round((per100.fat || 0) * w / 100 * 10) / 10,
      carbs:   ing.carbs != null ? Math.round((ing.carbs || 0) * 10) / 10 : Math.round((per100.carbs || 0) * w / 100 * 10) / 10,
      fiber:   ing.fiber != null ? Math.round((ing.fiber || 0) * 10) / 10 : (per100.fiber ? Math.round((per100.fiber || 0) * w / 100 * 10) / 10 : null),
      water:   ing.water != null ? Math.round((ing.water || 0) * 10) / 10 : (per100.water ? Math.round((per100.water || 0) * w / 100 * 10) / 10 : null),
      per100,
      vitamins: ing.vitamins || null,
      // Восстанавливаем раскладку крупы/пасты из сохранённого блюда, иначе
      // при редактировании не видно, что вес готовый, а КБЖУ взяты от сухого.
      _grain: ing.grain || null,
      _grainParts: ing.grain_components || null,
      _cooking: ing.cooking || null,
    }
    if (hasSubIngredients) {
      item.ingredients = ing.ingredients.map(subIng => ({
        name: subIng.name,
        weight_g: Math.round(subIng.weight_g || 0),
        per100: subIng.per100 || {},
        product_id: subIng.product_id || null,
        db_name: subIng.db_name || null,
        matched: !!subIng.product_id,
        source: subIng.source || null,
        vitamins: subIng.vitamins || null,
        nutrients: subIng.nutrients || null,
        _grain: subIng.grain || null,
        _cooking: subIng.cooking || null,
      }))
      if (ing.cooking_method) item.cooking_method = ing.cooking_method
    }
    return item
  })
}

async function onRecentClick(item) {
  page2Mode.value = 'repeat'
  page2Voice.value = false
  page2Transcript.value = ''
  page2CookedWeightG.value = null
  page2PortionsCount.value = null

  if (item.dish_id) {
    // Загружаем рецепт через cooking API — он возвращает правильные абсолютные веса
    try {
      const { data } = await api.get(`/cooking/dish/${item.dish_id}`)
      page2CookedWeightG.value = data.dish?.cooked_weight_g || null
      page2PortionsCount.value = Number(data.dish?.portions_count) || null
      if (data.recipe_ingredients?.length > 0) {
        page2Items.value = mergeEntryUnits(mapRecipeIngredientsToItems(data.recipe_ingredients), item.entries || data.entries)
      } else {
        page2Items.value = item.entries ? mapEntriesToItems(item.entries) : []
      }
    } catch {
      page2Items.value = item.entries ? mapEntriesToItems(item.entries) : []
    }
  } else {
    page2Items.value = item.entries ? mapEntriesToItems(item.entries) : []
  }

  page2PhotoUrl.value = item.photo_url
  page2DishName.value = item.name || null
  page2Confidence.value = 0
  page2Base64.value = null
  page2RecognitionId.value = null
  page2DishId.value = item.dish_id || null
  page2IsFavorite.value = item.is_favorite || false
  page2IsEditedCooking.value = item.is_edited_cooking || false
  if (!page2CookedWeightG.value) page2CookedWeightG.value = item.cooked_weight_g || null
  showPage2.value = true
}

function onPhotoAdded(entries, dishNameFromDialog) {
  for (const entry of entries) {
    if (dishNameFromDialog) entry.dish_name = dishNameFromDialog
    emit('added', entry)
  }
  emit('close')
}

// ── Фото (камера / галерея) ──────────────────────────
const cameraInput = ref(null)
const galleryInput = ref(null)
const photoPreviewUrl = ref(null)
const photoError = ref('')

async function openCamera() {
  guide.done('add_ways')
  // Бесплатные распознавания кончились — пейвол до съёмки (lib/freeLimits.js)
  if (authStore.quotaExhausted('rec')) { authStore.openFirstPaywall('photo'); return }
  if (!authStore.hasAiAccess) { authStore.showPaywall = true; return }
  guide.journey('j_camera')

  // Android PWA: запрашиваем разрешение камеры перед открытием (иначе input capture молча не срабатывает)
  const isAndroid = /android/i.test(navigator.userAgent)
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches
  if (isAndroid && isStandalone && navigator.mediaDevices?.getUserMedia) {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true })
      stream.getTracks().forEach(t => t.stop())
    } catch (e) {
      alert('Для съёмки еды нужен доступ к камере. Разрешите доступ в настройках браузера.')
      return
    }
  }

  track('photo_taken', { source: 'camera' })
  cameraInput.value?.click()
}

function openGallery() {
  if (authStore.quotaExhausted('rec')) { authStore.openFirstPaywall('photo'); return }
  if (!authStore.hasAiAccess) { authStore.showPaywall = true; return }
  track('photo_taken', { source: 'gallery' })
  galleryInput.value?.click()
}

function onBarcode() {
  guide.done('add_ways')
  guide.journey('j_barcode')
  showBarcodeScanner.value = true
}

// Ответ модели (фото или голос) → позиции окна результата: ингредиенты есть,
// КБЖУ пока пустые — их подберёт enrichAllItems
function mapRecognizedItems(rawItems) {
  return rawItems.map(item => {
    const itemType = item.type || 'recipe'
    const ingredients = (itemType === 'direct' || itemType === 'package') ? [] : (item.ingredients || []).map(ing => ({
      name: ing.name,
      weight_g: ing.weight_g || 0,
      product_id: null,
      per100: {},
    }))
    // Корректируем округление весов ингредиентов
    const dishWeight = item.weight_g || 100
    if (ingredients.length > 0) {
      const ingSum = ingredients.reduce((s, ing) => s + ing.weight_g, 0)
      const diff = dishWeight - ingSum
      if (diff !== 0) {
        const heaviest = ingredients.reduce((a, b) => (a.weight_g >= b.weight_g ? a : b))
        heaviest.weight_g += diff
      }
    }
    return {
      name: item.name || (item.barcode ? `Продукт (${item.barcode})` : 'Неизвестный продукт'),
      type: itemType,
      weight_g: dishWeight,
      cooking_method: item.cooking_method || 'raw',
      fallback_kbju: item.fallback_kbju || null,
      ingredients,
      product_id: null,
      db_name: null,
      kcal: null,
      protein: null,
      fat: null,
      carbs: null,
      fiber: null,
      water: null,
      per100: {},
      // Поля для package-типа
      brand: item.brand || null,
      barcode: item.barcode || null,
      // Цифры с лицевой стороны на всю порцию вместо таблицы — не этикетка
      label_kbju: labelLooksPerPortion(item) ? null : (item.label_kbju || null),
      ingredients_text: item.ingredients_text || null,
    }
  })
}

async function onPhotoSelected(e) {
  const file = e.target.files?.[0]
  if (!file) return

  // Проверка квоты гостя перед распознаванием
  if (authStore.isGuest) {
    try {
      const { data } = await api.post('/ai/check-guest-quota')
      if (!data.allowed) {
        emit('close')
        authStore.showGuestLimit = true
        e.target.value = ''
        return
      }
    } catch (err) {
      if (err.response?.data?.error === 'guest_recognition_limit') {
        emit('close')
        e.target.value = ''
        return // interceptor уже показал popup
      }
    }
  }

  photoPreviewUrl.value = URL.createObjectURL(file)
  photoError.value = ''

  try {
    // 1536 px, а не 1024: у Gemini 3.x цена картинки на входе фиксирована
    // уровнем разрешения (1112 токенов по умолчанию) и от пикселей не зависит —
    // проверено на снимках от 384 до 3072 px. Более крупное фото модель видит
    // подробнее за те же деньги; платим только объёмом загрузки (~450 КБ
    // против ~190) и местом в S3, куда этот же снимок потом ложится.
    const base64 = await resizeAndEncode(file, 1536)
    const mime = file.type || 'image/jpeg'

    // Сразу открываем PhotoRecognizeDialog в режиме загрузки
    page2Mode.value = 'photo'
    page2Voice.value = false
    page2Transcript.value = ''
    page2PortionsCount.value = null
    page2Items.value = []
    page2Confidence.value = 0
    page2DishName.value = null
    page2RecognitionId.value = null
  
    page2Base64.value = base64
    page2Mime.value = mime
    page2PhotoUrl.value = null
    page2DishId.value = null
    page2IsFavorite.value = false
    page2Loading.value = true
    showPage2.value = true

    // Единый промпт Gemini — название + ингредиенты (без КБЖУ)
    // job — номер запроса для шторки «переключили на резервную модель»
    const geminiResult = await withAiJob(job => callGemini(base64, mime, 2, job))
    page2RecognitionId.value = geminiResult._recognitionId || null

    if (!geminiResult.items || geminiResult.items.length === 0) {
      showPage2.value = false
      page2Loading.value = false
      photoError.value = 'На фото не удалось найти еду. Попробуйте другое фото.'
      e.target.value = ''
      return
    }

    // Формируем items с ингредиентами (КБЖУ пока null — будут после enrich)
    const items = mapRecognizedItems(geminiResult.items)

    page2Confidence.value = geminiResult.confidence
    page2DishName.value = geminiResult.dish_name || null

    // Проверяем, есть ли package-item для ревью:
    // 1) с label_kbju (данные с этикетки) — ревью для проверки
    // 2) с barcode но без label_kbju (только штрихкод) — попытка lookup, затем ревью
    const pkgItem = items.find(it => it.type === 'package' && (it.label_kbju?.kcal != null || it.barcode))

    if (pkgItem) {
      // Пробуем barcode lookup (если Gemini извлёк штрихкод)
      let foundByBarcode = false
      if (pkgItem.barcode) {
        try {
          const { data } = await api.get(`/products/barcode/${encodeURIComponent(pkgItem.barcode)}`)
          if (data.product?.id) {
            pkgItem.product_id = data.product.id
            pkgItem.db_name = data.product.name
            pkgItem.name = data.product.name
            pkgItem.per100 = { kcal: data.product.kcal, protein: data.product.protein,
                               fat: data.product.fat, carbs: data.product.carbs }
            const w = pkgItem.weight_g || 100
            const calc = v => v != null ? Math.round(v * w / 100 * 10) / 10 : null
            pkgItem.kcal = calc(data.product.kcal)
            pkgItem.protein = calc(data.product.protein)
            pkgItem.fat = calc(data.product.fat)
            pkgItem.carbs = calc(data.product.carbs)
            pkgItem.matched = true
            pkgItem._usedFallback = false
            pkgItem._submitted = true
            foundByBarcode = true
            page2DishName.value = data.product.name
          }
        } catch { /* not found by barcode */ }
      }

      if (!foundByBarcode) {
        // Открываем LabelReviewDialog напрямую, БЕЗ показа PhotoRecognizeDialog
        showPage2.value = false
        page2Loading.value = false
        page2Items.value = items
        packageReviewItem.value = pkgItem
        showPackageReview.value = true
        e.target.value = ''
        return  // ждём callback onPackageReviewSubmitted / onPackageReviewClosed
      }
    }

    // Показываем PhotoRecognizeDialog — ингредиенты видны, КБЖУ пока загружаются
    page2Items.value = items
    page2Loading.value = false

    // Обогащаем КБЖУ + витамины из БД Скурихина
    page2Enriching.value = true
    enrichAllItems(items)
      .catch(err => console.error('Enrich error:', err))
      .finally(() => { page2Enriching.value = false })
  } catch (err) {
    showPage2.value = false
    page2Loading.value = false
    if (isAiAccessError(err)) { e.target.value = ''; return }
    const msg = err.message || ''
    if (msg.includes('Resource exhausted') || msg.includes('429')) {
      photoError.value = 'Сервис распознавания временно перегружен. Попробуйте через несколько секунд.'
    } else if (msg.includes('timeout') || msg.includes('TimeoutError')) {
      photoError.value = 'Сервер не ответил вовремя. Проверьте подключение и попробуйте снова.'
    } else if (msg.includes('Не дождались ответа')) {
      // callGemini уже отличил сетевой сбой от прочих и отправил отчет —
      // повторять его вывод своими словами незачем.
      photoError.value = msg
    } else {
      // Сюда попадает всё остальное, включая исключения нашего же кода. Про
      // подключение здесь говорить нельзя: связь бывает в полном порядке, а
      // падает сборка приложения. Именно так опечатка в auth-store три недели
      // выглядела сетевым сбоем — человек шёл проверять вайфай, а на экране
      // была ошибка кода, о которой мы не знали. Отчет об этом уходит из
      // callGemini (там ветка !err.response ловит и ReferenceError).
      photoError.value = 'Не получилось. Попробуйте ещё раз.'
    }
  }

  e.target.value = ''
}

// ── Голосовой ввод ───────────────────────────────────
// Человек наговаривает, что съел; запись уходит в POST /ai/recognize-voice,
// ответ — тот же JSON, что у фото, плюс transcript. Дальше всё как после
// снимка: то же окно результата, тот же подбор КБЖУ. Запись не сохраняется.
const voiceSupported = typeof navigator !== 'undefined'
  && !!navigator.mediaDevices?.getUserMedia && typeof window.MediaRecorder !== 'undefined'
const showVoiceSheet = ref(false)
const page2Voice = ref(false)
// Иконки продуктов для окна результата без фото (голос): подбираются по
// названиям через POST /diary/food-icons параллельно с КБЖУ, порядок и
// предел четыре — как у карточки в MealGroup. Сбрасываются с закрытием окна,
// чтобы не утечь в следующий повтор или фото.
const page2Icons = ref([])
let page2IconsSeq = 0
watch(showPage2, (v) => { if (!v) { page2Icons.value = []; page2IconsSeq++ } })
async function loadPage2Icons(items) {
  const seq = ++page2IconsSeq
  const names = [...items].sort((a, b) => (b.weight_g || 0) - (a.weight_g || 0)).map(i => i.name).filter(Boolean)
  if (!names.length) return
  try {
    const { data } = await api.post('/diary/food-icons', { names }, { timeout: 15000 })
    if (seq !== page2IconsSeq) return
    const keys = []
    for (const n of names) {
      const k = data?.icons?.[n]
      if (k && !keys.includes(k)) keys.push(k)
      if (keys.length === 4) break
    }
    page2Icons.value = keys
  } catch (err) {
    console.error('Food icons error:', err)
  }
}
const page2Transcript = ref('')

// Долгое нажатие на микрофон — как в мессенджерах: люди по привычке
// зажимают кнопку, а на iOS долгое касание отменяет click. Поэтому через
// 450 мс удержания запись открывается сама, а последовавший click
// пропускается, чтобы шторка не открылась дважды.
let voiceHoldTimer = null
let voiceHoldFired = false
function onVoiceHoldStart(e) {
  if (e.pointerType === 'mouse' && e.button !== 0) return
  voiceHoldFired = false
  clearTimeout(voiceHoldTimer)
  voiceHoldTimer = setTimeout(() => { voiceHoldFired = true; openVoice() }, 450)
}
function onVoiceHoldEnd() { clearTimeout(voiceHoldTimer) }
function onVoiceClick() {
  if (voiceHoldFired) { voiceHoldFired = false; return }
  openVoice()
}

// Гость: три голосовых добавления за жизнь аккаунта (api/ai.js,
// GUEST_VOICE_LIMIT). Сервер спрашиваем до записи, чтобы четвёртое нажатие
// сразу показало пейвол «Продолжим?» (его открывает перехватчик в
// services/api.js), а не после того, как человек надиктовал. Сбой сети —
// не повод не пускать: при распознавании сервер проверит ещё раз.
let voiceQuotaChecking = false
async function openVoice() {
  guide.done('add_ways')
  if (authStore.quotaExhausted('rec')) { authStore.openFirstPaywall('voice'); return }
  guide.journey('j_voice')
  if (!authStore.hasAiAccess) { authStore.showPaywall = true; return }
  if (authStore.isGuest) {
    if (voiceQuotaChecking) return
    voiceQuotaChecking = true
    try {
      await api.post('/ai/check-guest-quota', { kind: 'voice' }, { timeout: 5000 })
    } catch (err) {
      const code = err.response?.data?.error
      if (code === 'guest_voice_limit' || code === 'guest_recognition_limit') {
        track('voice_guest_limit')
        return
      }
    } finally {
      voiceQuotaChecking = false
    }
  }
  photoError.value = ''
  track('voice_opened')
  showVoiceSheet.value = true
}

async function onVoiceRecorded({ base64, mime, durationMs }) {
  showVoiceSheet.value = false
  if (!base64) return

  // Окно результата — сразу, в режиме загрузки, без фото
  page2Mode.value = 'photo'
  page2Voice.value = true
  page2Transcript.value = ''
  page2PortionsCount.value = null
  page2Items.value = []
  page2Confidence.value = 0
  page2DishName.value = null
  page2RecognitionId.value = null
  page2Base64.value = null
  page2Mime.value = 'image/jpeg'
  page2PhotoUrl.value = null
  photoPreviewUrl.value = null
  page2DishId.value = null
  page2IsFavorite.value = false
  page2Loading.value = true
  showPage2.value = true

  try {
    const { data } = await api.post('/ai/recognize-voice', { audio: base64, mime_type: mime }, { timeout: 90000 })
    authStore.bumpQuota('rec')
    const result = data?.result || {}
    track('voice_recognized', { duration_ms: durationMs, items_count: result.items?.length || 0 })

    if (!result.items?.length) {
      showPage2.value = false
      page2Loading.value = false
      const heard = String(result.transcript || '').trim()
      photoError.value = heard
        ? `В записи не нашлось еды. Я услышала: «${heard.slice(0, 200)}». Попробуйте ещё раз.`
        : 'Не удалось расслышать запись. Попробуйте ещё раз — ближе к микрофону и без шума.'
      return
    }

    const items = mapRecognizedItems(result.items)
    page2RecognitionId.value = data.recognition_id || null
    page2Confidence.value = Number(result.confidence) || 0
    page2DishName.value = result.dish_name || null
    page2Transcript.value = String(result.transcript || '').trim()
    page2Items.value = items
    page2Loading.value = false

    page2Enriching.value = true
    enrichAllItems(items)
      .catch(err => console.error('Enrich error:', err))
      .finally(() => { page2Enriching.value = false })
    loadPage2Icons(items)
  } catch (err) {
    showPage2.value = false
    page2Loading.value = false
    const status = err.response?.status
    const code = err.response?.data?.error
    // Дневной лимит и гостевые квоты: окно уже показал перехватчик в services/api.js
    if (isAiAccessError(err)) return
    if (status === 413) {
      photoError.value = 'Запись слишком длинная. Попробуйте короче — до минуты.'
    } else if (!err.response && err.isAxiosError) {
      photoError.value = 'Не дождались ответа. Проверьте подключение и попробуйте снова.'
    } else {
      photoError.value = (typeof code === 'string' && /[а-яё]/i.test(code)) ? code : 'Не получилось. Попробуйте ещё раз.'
    }
  }
}

// ── Callbacks для package review ──

let _packageSubmitted = false

function onPackageReviewSubmitted(result) {
  _packageSubmitted = true
  const item = packageReviewItem.value
  if (!item) return
  const p = result.product
  item.product_id = p.id
  item.db_name = p.name
  item.name = p.name
  item.matched = true
  item._submitted = true
  item._usedFallback = false
  item._hasLabelData = false
  item.type = 'direct'
  item.per100 = { kcal: p.kcal, protein: p.protein, fat: p.fat, carbs: p.carbs }
  const w = item.weight_g || 100
  const calc = v => v != null ? Math.round(v * w / 100 * 10) / 10 : null
  item.kcal = calc(p.kcal)
  item.protein = calc(p.protein)
  item.fat = calc(p.fat)
  item.carbs = calc(p.carbs)
  page2DishName.value = p.name
  finishPackageReview()
}

function onPackageFoundExisting(product, labelPer100 = null) {
  _packageSubmitted = true
  const item = packageReviewItem.value
  if (!item) return
  item.product_id = product.id
  item.db_name = product.name
  item.name = product.name
  item.matched = true
  item._usedFallback = false
  item.type = 'direct'

  // Этикетка важнее найденной по штрихкоду записи: пользователь только что
  // сфотографировал именно эту упаковку. Раньше продукт замещал её целиком, и
  // запись из Open Food Facts с одной калорийностью превращала распознанные
  // 11,5 г углеводов в ноль. Теперь продукт лишь дополняет пропуски.
  const per100 = {
    kcal:    labelPer100?.kcal    ?? product.kcal    ?? null,
    protein: labelPer100?.protein ?? product.protein ?? null,
    fat:     labelPer100?.fat     ?? product.fat     ?? null,
    carbs:   labelPer100?.carbs   ?? product.carbs   ?? null,
    fiber:   product.fiber ?? null,
    water:   product.water ?? null,
  }
  item.per100 = per100
  const w = item.weight_g || 100
  const calc = v => v != null ? Math.round(v * w / 100 * 10) / 10 : null
  item.kcal = calc(per100.kcal)
  item.protein = calc(per100.protein)
  item.fat = calc(per100.fat)
  item.carbs = calc(per100.carbs)
  item.fiber = calc(per100.fiber)
  item.water = calc(per100.water)
  page2DishName.value = product.name
  finishPackageReview()
}

function onPackageReviewClosed() {
  if (_packageSubmitted) { _packageSubmitted = false; return }
  showPackageReview.value = false
  packageReviewItem.value = null
  page2Loading.value = false
  page2Items.value = []
  showPage2.value = false
}

function finishPackageReview() {
  showPackageReview.value = false
  packageReviewItem.value = null
  showPage2.value = true          // показать PhotoRecognizeDialog после package review
  page2Loading.value = false
  page2Enriching.value = true
  enrichAllItems(page2Items.value)
    .catch(err => console.error('Enrich error:', err))
    .finally(() => { page2Enriching.value = false })
}

// ── Обогащение items через /ai/recipe-lookup или /ai/direct-lookup ──
async function enrichAllItems(items) {
  await Promise.all(items.map(async (item) => {
    if (item._ingredientsEdited) return
    // Пропуск уже проверенных/сохранённых через package review или LabelReviewDialog
    if (item._submitted && item.product_id) return
    item._enrichFailed = false
    try {
      // type="package" → barcode lookup → direct-lookup → label_kbju fallback
      if (item.type === 'package') {

        // 1. Barcode lookup (если Gemini извлёк штрихкод)
        if (item.barcode) {
          try {
            const { data } = await api.get(`/products/barcode/${encodeURIComponent(item.barcode)}`)
            if (data.product?.id) {
              item.product_id = data.product.id
              item.db_name = data.product.name
              item.name = data.product.name
              // Клетчатка и вода тоже приходят из БД — без них дневник
              // недосчитывался бы этих строк при добавлении по штрихкоду.
              item.per100 = { kcal: data.product.kcal, protein: data.product.protein,
                              fat: data.product.fat, carbs: data.product.carbs,
                              fiber: data.product.fiber ?? null, water: data.product.water ?? null }
              const w = item.weight_g || 100
              const calc = v => v != null ? Math.round(v * w / 100 * 10) / 10 : null
              item.kcal = calc(data.product.kcal)
              item.protein = calc(data.product.protein)
              item.fat = calc(data.product.fat)
              item.carbs = calc(data.product.carbs)
              item.fiber = calc(data.product.fiber)
              item.water = calc(data.product.water)
              item.matched = true
              item._usedFallback = false
              return
            }
          } catch { /* not found by barcode */ }
        }

        // 2. Есть label_kbju — используем как КБЖУ (без автосабмита в БД).
        //
        // Этикетка в приоритете: это состав конкретной упаковки, он точнее
        // усреднённых данных справочника. Но распознаётся она неровно — бывает,
        // что видна только калорийность. Раньше этого хватало, чтобы выйти
        // отсюда с тремя null и не заглянуть в базу, где у продукта есть и
        // белки, и углеводы: человек получал «0 г углеводов» у яблочного сока.
        // Поэтому недостающие поля добираем из базы, не трогая распознанные.
        const kbju = item.label_kbju
        if (kbju && kbju.kcal != null) {
          const w = item.weight_g || 100
          const calc = v => v != null ? Math.round(v * w / 100 * 10) / 10 : null

          let fill = null
          if (kbju.protein == null || kbju.fat == null || kbju.carbs == null) {
            try {
              const { data } = await api.post('/ai/direct-lookup', {
                name: item.name,
                weight_g: item.weight_g,
                cooking_method: 'raw',
                fallback_kbju: null,
              }, { idempotent: true })
              if (data.matched && data.per100) fill = data.per100
            } catch { /* база не ответила — остаёмся с тем, что дала этикетка */ }
          }

          const per100 = {
            kcal:    kbju.kcal,
            protein: kbju.protein ?? fill?.protein ?? null,
            fat:     kbju.fat     ?? fill?.fat     ?? null,
            carbs:   kbju.carbs   ?? fill?.carbs   ?? null,
            fiber:   fill?.fiber ?? null,
            water:   fill?.water ?? null,
          }
          item.per100 = per100
          item.kcal = calc(per100.kcal)
          item.protein = calc(per100.protein)
          item.fat = calc(per100.fat)
          item.carbs = calc(per100.carbs)
          item.fiber = calc(per100.fiber)
          item.water = calc(per100.water)
          item._hasLabelData = true
          item.matched = false
          item._usedFallback = false
          return
        }

        // 3. Нет label_kbju — direct-lookup по имени
        try {
          const { data } = await api.post('/ai/direct-lookup', {
            name: item.name,
            weight_g: item.weight_g,
            cooking_method: 'raw',
            fallback_kbju: item.fallback_kbju,
          }, { idempotent: true })
          if (data.matched) {
            item.product_id = data.product_id
            item.db_name = data.db_name
            item._grainParts = data.components || null
            item._grain = data.grain || null
            item._cooking = data.cooking || null
            // Название карточки вместо распознанного — только при уверенном
            // совпадении. При слабом человек видел бы чужое имя («Напиток
            // яблочный» вместо протеинового молока, 18.10.2026) и решал, что Зоя
            // не узнала продукт; карточка остаётся строкой «→ …» под названием.
            // Старый сервер похожесть не присылает — тогда как раньше.
            if (data.similarity == null || data.similarity >= STRONG_NAME_SIMILARITY) item.name = data.db_name || item.name
            item.kcal = data.kcal
            item.protein = data.protein
            item.fat = data.fat
            item.carbs = data.carbs
            item.per100 = data.per100
            item.matched = true
            item._usedFallback = false
            return
          }
        } catch {}

        // 4. Не найден — fallback_kbju (оценка ИИ)
        if (item.fallback_kbju) {
          item.kcal = Math.round((item.fallback_kbju.kcal || 0) * 10) / 10
          item.protein = Math.round((item.fallback_kbju.protein || 0) * 10) / 10
          item.fat = Math.round((item.fallback_kbju.fat || 0) * 10) / 10
          item.carbs = Math.round((item.fallback_kbju.carbs || 0) * 10) / 10
          item.per100 = {
            kcal: item.weight_g > 0 ? Math.round(item.fallback_kbju.kcal / item.weight_g * 100 * 10) / 10 : null,
            protein: item.weight_g > 0 ? Math.round((item.fallback_kbju.protein || 0) / item.weight_g * 100 * 10) / 10 : null,
            fat: item.weight_g > 0 ? Math.round((item.fallback_kbju.fat || 0) / item.weight_g * 100 * 10) / 10 : null,
            carbs: item.weight_g > 0 ? Math.round((item.fallback_kbju.carbs || 0) / item.weight_g * 100 * 10) / 10 : null,
          }
          item.matched = false
          item._usedFallback = true
          item._hasLabelData = false
        }
        return
      }

      // type="direct" → direct-lookup (один продукт, без ингредиентов)
      if (item.type === 'direct') {
        const requestWeight = item.weight_g
        const { data } = await api.post('/ai/direct-lookup', {
          name: item.name,
          weight_g: requestWeight,
          cooking_method: item.cooking_method || 'raw',
          fallback_kbju: item.fallback_kbju || null,
        }, { idempotent: true })
        item.product_id = data.product_id
        item.db_name = data.db_name
        item._grainParts = data.components || null
        item._grain = data.grain || null
        item._cooking = data.cooking || null
        item.per100 = data.per100
        // Пересчитываем КБЖУ и витамины по ТЕКУЩЕМУ весу (мог измениться пока шёл запрос)
        const currentWeight = item.weight_g
        const calc = (v) => v != null ? Math.round(v * currentWeight / 100 * 10) / 10 : null
        item.kcal = calc(data.per100?.kcal)
        item.protein = calc(data.per100?.protein)
        item.fat = calc(data.per100?.fat)
        item.carbs = calc(data.per100?.carbs)
        item.fiber = calc(data.per100?.fiber)
        item.water = calc(data.per100?.water)
        // Витамины: API вернул для requestWeight, пересчитываем на currentWeight
        let vit = data.vitamins && Object.keys(data.vitamins).length > 0 ? data.vitamins : null
        if (vit && requestWeight > 0 && currentWeight !== requestWeight) {
          const ratio = currentWeight / requestWeight
          const rescaled = {}
          for (const [k, v] of Object.entries(vit)) {
            if (k === '_no_vitamins') { rescaled[k] = v; continue }
            rescaled[k] = Math.round(v * ratio * 100) / 100
          }
          vit = rescaled
        }
        item._totalVitamins = vit
        if (data._no_vitamins?.length) item._noVitamins = data._no_vitamins
        item._usedFallback = data._usedFallback || false
        item.matched = data.matched
        if (data.source) item._dbSource = data.source
        return
      }

      // type="recipe" (default) → recipe-lookup
      if (!item.ingredients?.length) return
      const { data } = await api.post('/ai/recipe-lookup', {
        items: item.ingredients.map(ing => ({
          name: ing.name,
          weight_g: ing.weight_g,
        })),
        cooking_method: item.cooking_method || 'raw',
        dish_name: item.name,
        fallback_kbju: item.fallback_kbju || null,
      }, { idempotent: true })
      if (data.items) {
        for (let i = 0; i < item.ingredients.length && i < data.items.length; i++) {
          const enriched = data.items[i]
          item.ingredients[i].per100 = enriched.per100
          item.ingredients[i].product_id = enriched.product_id
          item.ingredients[i].db_name = enriched.db_name
          item.ingredients[i]._grain = enriched.grain || null
          item.ingredients[i]._cooking = enriched.cooking || null
          item.ingredients[i].vitamins = enriched.vitamins || {}
          item.ingredients[i].matched = enriched.matched
          if (enriched.source) item.ingredients[i]._dbSource = enriched.source
        }
        item._totalVitamins = data.total_vitamins
        if (data.no_vitamins?.length) item._noVitamins = data.no_vitamins
      }
      // Пересчитываем КБЖУ item из ингредиентов
      recalcItemFromIngredients(item)

      // Если суммарный kcal = 0 и есть fallback — применяем fallback
      if ((item.kcal === 0 || item.kcal == null) && data._usedFallback && item.fallback_kbju) {
        item.kcal = Math.round((item.fallback_kbju.kcal || 0) * 10) / 10
        item.protein = Math.round((item.fallback_kbju.protein || 0) * 10) / 10
        item.fat = Math.round((item.fallback_kbju.fat || 0) * 10) / 10
        item.carbs = Math.round((item.fallback_kbju.carbs || 0) * 10) / 10
        item._usedFallback = true
      }
    } catch (err) {
      console.error('Enrich error for', item.name, err)
      // Флаг уезжает в PhotoRecognizeDialog через page2Items: там кнопка «Повторить»
      item._enrichFailed = true
    }
  }))
  // Триггерим реактивность Vue
  page2Items.value = [...items]
}

function recalcItemFromIngredients(item) {
  if (!item.ingredients?.length) return
  let kcal = 0, protein = 0, fat = 0, carbs = 0, fiber = 0, water = 0
  for (const ing of item.ingredients) {
    const w = ing.weight_g || 0
    const p = ing.per100 || {}
    kcal    += (p.kcal || 0) * w / 100
    protein += (p.protein || 0) * w / 100
    fat     += (p.fat || 0) * w / 100
    carbs   += (p.carbs || 0) * w / 100
    fiber   += (p.fiber || 0) * w / 100
    water   += (p.water || 0) * w / 100
  }
  item.kcal    = Math.round(kcal * 10) / 10
  item.protein = Math.round(protein * 10) / 10
  item.fat     = Math.round(fat * 10) / 10
  item.carbs   = Math.round(carbs * 10) / 10
  item.fiber   = Math.round(fiber * 10) / 10
  item.water   = Math.round(water * 10) / 10
  // Обновляем per100 для совместимости
  const w = item.weight_g || 1
  item.per100 = {
    kcal:    Math.round(item.kcal / w * 100 * 10) / 10,
    protein: Math.round(item.protein / w * 100 * 10) / 10,
    fat:     Math.round(item.fat / w * 100 * 10) / 10,
    carbs:   Math.round(item.carbs / w * 100 * 10) / 10,
    fiber:   Math.round(item.fiber / w * 100 * 10) / 10,
    water:   Math.round(item.water / w * 100 * 10) / 10,
  }
}

// ── Gemini: распознавание фото + ингредиенты (единый промпт) ──

const DEFAULT_PHOTO_PROMPT = `Ты — эксперт-диетолог. Посмотри на фото еды.
Определи все продукты и блюда, оцени вес каждого.

Каждый item имеет поле "type":
- "recipe" — блюдо, которое нужно разложить на ингредиенты (борщ, плов, салат, паста с соусом)
- "direct" — простой натуральный продукт БЕЗ видимой этикетки/упаковки (яблоко, сыр, хлеб, крупа) или напиток (вино, пиво, сок, кофе, чай)
- "package" — продукт с видимой упаковкой, этикеткой, таблицей пищевой ценности или штрихкодом. ВАЖНО: если на фото видна таблица КБЖУ/пищевой ценности или этикетка с составом — это ВСЕГДА type="package", даже для простых продуктов (молоко, кефир, мацони, творог в упаковке)

Верни СТРОГО JSON (без markdown, без \`\`\`):
{
  "confidence": 85,
  "dish_name": "Обед с борщом",
  "items": [
    {
      "name": "Борщ",
      "type": "recipe",
      "weight_g": 300,
      "cooking_method": "boiling",
      "fallback_kbju": {"kcal": 180, "protein": 8, "fat": 7, "carbs": 18},
      "ingredients": [
        {"name": "Свёкла", "weight_g": 45},
        {"name": "Картофель", "weight_g": 40},
        {"name": "Капуста белокочанная", "weight_g": 35},
        {"name": "Говядина", "weight_g": 50},
        {"name": "Лук репчатый", "weight_g": 15},
        {"name": "Морковь", "weight_g": 15},
        {"name": "Томатная паста", "weight_g": 10},
        {"name": "Масло подсолнечное", "weight_g": 5},
        {"name": "Сметана", "weight_g": 15},
        {"name": "Вода", "weight_g": 70}
      ]
    },
    {
      "name": "Йогурт Epica клубника",
      "type": "package",
      "weight_g": 130,
      "cooking_method": "raw",
      "fallback_kbju": {"kcal": 120, "protein": 6, "fat": 4.8, "carbs": 13},
      "ingredients": [],
      "brand": "Epica",
      "barcode": null,
      "label_kbju": {"kcal": 92, "protein": 4.6, "fat": 3.7, "carbs": 10},
      "ingredients_text": "Молоко нормализованное, сахар, клубника, закваска"
    },
    {
      "name": "Вино красное",
      "type": "direct",
      "weight_g": 150,
      "cooking_method": "raw",
      "fallback_kbju": {"kcal": 102, "protein": 0.1, "fat": 0, "carbs": 2.6},
      "ingredients": []
    }
  ]
}

Правила:
- dish_name: общее название на русском (2-4 слова)
- type: "recipe" для блюд с декомпозицией, "direct" для простых натуральных продуктов и напитков без упаковки, "package" если видна упаковка/этикетка/таблица КБЖУ/штрихкод
- cooking_method: для КАЖДОГО item — raw, boiling, frying, baking, steaming, stewing
- fallback_kbju: для КАЖДОГО item — твоя оценка КБЖУ на ВЕСЬ weight_g (kcal, protein, fat, carbs)
- ingredients для type="recipe": базовые продукты с именами как в таблице Скурихина (русский язык).
  Вес каждого — такой, какой он занимает в ГОТОВОМ блюде. Крупы, макароны и бобовые указывай тоже варёным весом, а не сухим
- ingredients для type="direct" и "package": пустой массив []
- Поля только для type="package":
  - brand: название бренда/производителя, если видно на упаковке, иначе null
  - barcode: строка цифр под штрихкодом (обычно 13 цифр EAN), если читаема на фото, иначе null
  - label_kbju: КБЖУ на 100 г (для напитков — на 100 мл) из ТАБЛИЦЫ пищевой ценности, если она видна на фото (kcal, protein, fat, carbs, fiber). Иначе null. Это точные данные с этикетки, НЕ твоя оценка.
    Если таблица дана на порцию или на всю упаковку — пересчитай на 100 г по указанному в ней весу или объёму порции.
    Крупные цифры на лицевой стороне упаковки («33 g protein», «0% сахара», «High Protein») — это не таблица: учти их в fallback_kbju, а label_kbju оставь null.
    fiber — строка «Пищевые волокна» или «Клетчатка», она есть далеко не на каждой упаковке. Нет строки → fiber: null. НЕ ставь 0 и не выводи значение из состава: ноль значит «волокон нет», а null — «на упаковке не написано»
  - ingredients_text: текст состава продукта с этикетки (строка), если виден на фото. Иначе null. Копируй дословно как написано на упаковке
- Сумма weight_g ингредиентов ДОЛЖНА равняться weight_g блюда
- Обязательно включай воду/бульон для жидких блюд (супы, соусы)
- confidence: 0-100
- Если на фото видна ТОЛЬКО упаковка или ТОЛЬКО штрихкод (без самой еды) — это тоже type="package". НЕ возвращай пустой items!
- ВАЖНО: если на фото виден ТОЛЬКО штрихкод (без таблицы пищевой ценности, без состава, без этикетки с КБЖУ) — верни type="package" с ТОЛЬКО barcode (цифры под штрихкодом). НЕ ПРИДУМЫВАЙ И НЕ УГАДЫВАЙ название продукта, КБЖУ, бренд и состав! Верни: name: null, brand: null, label_kbju: null, fallback_kbju: null, ingredients_text: null, barcode: "цифры". Только если ты ВИДИШЬ таблицу КБЖУ на фото — заполняй label_kbju. Только если ты ВИДИШЬ название — заполняй name.
- "items": [] ТОЛЬКО если на фото вообще нет ни еды, ни упаковки, ни штрихкода`

function getPhotoPrompt() {
  return DEFAULT_PHOTO_PROMPT
}

async function callGemini(base64, mimeType, retries = 2, job = '') {
  const prompt = await getPhotoPrompt()

  let result
  // Тот же датчик, что на этикетке. Здесь он нужнее: вызовов на порядок
  // больше (3844 против 379 за две недели), а неудачи этого пути в
  // zoya_token_usage не попадают вовсе — расход пишет клиент отдельным
  // запросом уже после успеха, поэтому по базе они невидимы.
  const probe = startNetProbe()
  try {
    // model в query — для совместимости со старыми серверами: для метки
    // /photo/recognize сервер подставляет свою GEMINI_PHOTO_MODEL
    // (с 27.09.2026 gemini-3.1-flash-lite), см. api/ai.js.
    const { data } = await api.post(`/ai/gemini-proxy?model=gemini-2.5-flash&label=/photo/recognize&pv=${PHOTO_PROMPT_VERSION}&job=${job}`, {
      contents: [{
        parts: [
          { text: prompt },
          { inline_data: { mime_type: mimeType, data: base64 } },
        ],
      }],
      // Бюджет размышлений. По умолчанию модель тратит на них ~2200 токенов —
      // это 84% оплачиваемого выхода и почти всё время ответа: 13 секунд против
      // 5,6 при бюджете 512.
      //
      // Замер на 40 блюдах разных пользователей (scripts/compare-thinking-budget.js)
      // показал, что цена урезания невелика. Позиций при 512 даже больше (8,8
      // против 8,2), разбор JSON не сломался ни разу из 160 вызовов, а названия
      // совпадают на 71% при шумовом поле 73% — то есть модель расходится сама с
      // собой между двумя одинаковыми запросами почти настолько же. Реальная
      // разница одна: вес стабильнее, ±9% против ±14%.
      //
      // Кому этой стабильности не хватает — включает «максимально точно» в
      // настройках дневника, и тогда ограничения нет вовсе.
      ...(photoMaxQuality.value ? {} : { generationConfig: { thinkingConfig: { thinkingBudget: 512 } } }),
    }, { timeout: 120000 })
    probe.done()
    result = data
  } catch (err) {
    // isAxiosError обязателен. Без него сюда попадала любая ошибка нашего же
    // кода, брошенная после успешного ответа: отсутствие err.response читалось
    // как «сети нет». Так опечатка в auth-store (вызов функции, переименованной
    // в другом коммите) три недели выглядела сетевым сбоем, трижды повторяла
    // запрос и жгла токены Gemini на ответах, которые уже пришли.
    const isNetwork = !err.response && err.isAxiosError === true
    if (isAiAccessError(err)) { probe.done(); throw err }
    const is429 = err.response?.status === 429
    // Сообщаем и о сбое сети, и об исключении своего кода: ответа нет ни в
    // том, ни в другом случае, а отличить их можно только по коду в отчете.
    // Повторяем при этом лишь сетевые — см. isNetwork выше.
    if (!err.response) probe.lost('/photo/recognize', err, 3 - retries)
    else probe.done()
    if (retries > 0 && (is429 || isNetwork)) {
      await new Promise(r => setTimeout(r, 3000))
      return callGemini(base64, mimeType, retries - 1, job)
    }
    if (isNetwork) {
      throw new Error('Не дождались ответа — попробуйте ещё раз')
    }
    throw new Error(err.response?.data?.error?.message || err.message || 'Gemini error')
  }

  // Расход токенов считает сервер по ответу Gemini (метка — в query
  // запроса выше); здесь только обновление индикатора бюджета.
  authStore.fetchTokenBudget()
  authStore.bumpQuota('rec')

  const text = result.candidates?.[0]?.content?.parts?.[0]?.text?.trim() || ''
  const cleaned = text.replace(/```json\n?/g, '').replace(/```\n?/g, '').trim()

  let parsed
  try {
    parsed = JSON.parse(cleaned)
  } catch {
    throw new Error('Gemini вернул некорректный ответ')
  }
  // Номер записи в журнале распознаваний (lib/recognitionLog.js) — при
  // сохранении блюда возвращается серверу, чтобы связать ответ с правкой
  if (parsed && typeof parsed === 'object') parsed._recognitionId = result.zoya_recognition_id || null
  return parsed
}

function resizeAndEncode(file, maxPx) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    const url = URL.createObjectURL(file)
    img.onload = () => {
      URL.revokeObjectURL(url)
      const scale = Math.min(1, maxPx / Math.max(img.width, img.height))
      const w = Math.round(img.width * scale)
      const h = Math.round(img.height * scale)
      const canvas = document.createElement('canvas')
      canvas.width = w; canvas.height = h
      canvas.getContext('2d').drawImage(img, 0, 0, w, h)
      const dataUrl = canvas.toDataURL('image/jpeg', 0.85)
      resolve(dataUrl.split(',')[1])
    }
    img.onerror = reject
    img.src = url
  })
}
</script>

<style scoped>
.empty-state-bubble { margin: 28px 24px 36px; flex-shrink: 0; }
.empty-state-bubble p { margin: 0; }
.pill-kcal    { background: #EE998C; border-radius: 8px; padding: 2px 8px; color: var(--ink); }
.pill-protein { background: #9FC2C1; border-radius: 8px; padding: 2px 8px; color: var(--ink); }
.pill-fat     { background: #EBC06D; border-radius: 8px; padding: 2px 8px; color: var(--ink); }
.pill-carbs   { background: #EEAD77; border-radius: 8px; padding: 2px 8px; color: var(--ink); }
.pill-fiber   { background: #A6B779; border-radius: 8px; padding: 2px 8px; color: var(--ink); }

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Липкая полупрозрачная шапка (заголовок, вкладки, ряд тегов) — как нижнее
   меню (NavBar): кремовый фон 60 % и размытие 20 px. На всю ширину листа
   поверх отступов области прокрутки; верхние углы — как у листа. */
.afd-head {
  position: sticky;
  top: 0;
  z-index: 20;
  margin: 0 -20px;
  padding: 0 20px;
  border-radius: 24px 24px 0 0;
  background: rgba(250, 243, 232, 0.6);
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
}
/* Ряд тегов живёт внутри .afd-head: чипы уезжают под края листа, как и шапка */
.afd-tags {
  margin: 0 -20px;
  padding-left: 20px;
  padding-right: 20px;
}
/* Невыбранные теги — стекло как у «+» (.glass-fab в style.css): шоколадный
   тон 35 %, размытие 5 px, одна светлая кромка, плоский отблеск, кремовый
   текст с тонкой тенью. Кромка — сам бордюр чипа, а не внутренняя тень: с
   прозрачным бордюром и тенью внутри выходило два кольца (владелец,
   27.10.2026). Выбранный тег — прежний сплошной ink. Только в этом окне: в
   «Кулинарии» теги прежние. */
.afd-tags :deep(.fav-tag:not(.on)) {
  position: relative;
  isolation: isolate;
  border-color: rgba(255, 255, 255, .22);
  background: rgba(52, 32, 20, .35);
  -webkit-backdrop-filter: blur(5px) saturate(160%);
  backdrop-filter: blur(5px) saturate(160%);
  color: var(--cream);
  text-shadow: 0 1px 1.5px rgba(27, 17, 11, .5);
  box-shadow: 0 4px 10px -6px rgba(27, 17, 11, .35);
}
.afd-tags :deep(.fav-tag:not(.on))::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  z-index: -1;
  pointer-events: none;
  background: linear-gradient(160deg, rgba(255, 255, 255, .16) 0%, rgba(255, 255, 255, .04) 45%, rgba(255, 255, 255, 0) 60%);
}
</style>
